/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../../common/sort';
import './enums';
import '../../common/money';
import '../../common/measurement_units';
import '../../common/source_application';
import '../../resources/address';
import '../../common/coordinates';
import '../../common/day_of_week';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "connect": {
        "nested": {
          "v2": {
            "nested": {
              "merchant_catalog": {
                "nested": {
                  "resources": {
                    "nested": {
                      "CatalogIdMapping": {
                        "fields": {
                          "clientObjectId": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "objectId": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "CatalogObjectBatch": {
                        "fields": {
                          "objects": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogObject",
                            "id": 1,
                            "rule": "repeated"
                          }
                        }
                      },
                      "CatalogQuery": {
                        "fields": {
                          "sortedAttributeQuery": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogQuery.SortedAttribute",
                            "id": 1,
                            "rule": "optional"
                          },
                          "exactQuery": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogQuery.Exact",
                            "id": 2,
                            "rule": "optional"
                          },
                          "setQuery": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogQuery.Set",
                            "id": 13,
                            "rule": "optional"
                          },
                          "prefixQuery": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogQuery.Prefix",
                            "id": 3,
                            "rule": "optional"
                          },
                          "rangeQuery": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogQuery.Range",
                            "id": 4,
                            "rule": "optional"
                          },
                          "textQuery": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogQuery.Text",
                            "id": 5,
                            "rule": "optional"
                          },
                          "itemsForTaxQuery": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogQuery.ItemsForTax",
                            "id": 6,
                            "rule": "optional"
                          },
                          "itemsForModifierListQuery": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogQuery.ItemsForModifierList",
                            "id": 7,
                            "rule": "optional"
                          },
                          "itemsForItemOptionsQuery": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogQuery.ItemsForItemOptions",
                            "id": 8,
                            "rule": "optional"
                          },
                          "itemVariationsForItemOptionValuesQuery": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogQuery.ItemVariationsForItemOptionValues",
                            "id": 9,
                            "rule": "optional"
                          },
                          "filteredItemsQuery": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogQuery.FilteredItems",
                            "id": 10,
                            "rule": "optional"
                          },
                          "customAttributeUsage": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogQuery.CustomAttributeUsage",
                            "id": 11,
                            "rule": "optional"
                          },
                          "pricingObjectsForProductsQuery": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogQuery.PricingObjectsForProducts",
                            "id": 14,
                            "rule": "optional"
                          },
                          "checkoutLinkForItems": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogQuery.CheckoutLinksForItems",
                            "id": 15,
                            "rule": "optional"
                          },
                          "legacyIdsQuery": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogQuery.LegacyIds",
                            "id": 17,
                            "rule": "optional"
                          },
                          "sortedStringIntAttributeQuery": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogQuery.SortedStringIntAttribute",
                            "id": 18,
                            "rule": "optional"
                          },
                          "doesNotExistQuery": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogQuery.DoesNotExist",
                            "id": 19,
                            "rule": "optional"
                          },
                          "presentAtLocationsQuery": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogQuery.PresentAtLocations",
                            "id": 20,
                            "rule": "optional"
                          },
                          "booleanAttributeQuery": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogQuery.BooleanAttribute",
                            "id": 21,
                            "rule": "repeated"
                          }
                        },
                        "nested": {
                          "SortedAttribute": {
                            "fields": {
                              "attributeName": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "initialAttributeValue": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                              },
                              "sortOrder": {
                                "type": "squareup.connect.v2.common.SortOrder",
                                "id": 3,
                                "rule": "optional",
                                "options": {
                                  "default": "ASC"
                                }
                              },
                              "includeObjectsMissingAttribute": {
                                "type": "bool",
                                "id": 4,
                                "rule": "optional",
                                "options": {
                                  "default": false
                                }
                              }
                            }
                          },
                          "SortedStringIntAttribute": {
                            "fields": {
                              "attributeName": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "attributeValue": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                              },
                              "sortOrder": {
                                "type": "squareup.connect.v2.common.SortOrder",
                                "id": 3,
                                "rule": "optional",
                                "options": {
                                  "default": "ASC"
                                }
                              },
                              "initialIntValue": {
                                "type": "int64",
                                "id": 4,
                                "rule": "optional"
                              }
                            }
                          },
                          "Exact": {
                            "fields": {
                              "attributeName": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "attributeValue": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                              }
                            }
                          },
                          "Set": {
                            "fields": {
                              "attributeName": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "attributeValues": {
                                "type": "string",
                                "id": 2,
                                "rule": "repeated"
                              }
                            }
                          },
                          "Prefix": {
                            "fields": {
                              "attributeName": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "attributePrefix": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                              }
                            }
                          },
                          "Range": {
                            "fields": {
                              "attributeName": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "attributeMinValue": {
                                "type": "int64",
                                "id": 2,
                                "rule": "optional"
                              },
                              "attributeMaxValue": {
                                "type": "int64",
                                "id": 3,
                                "rule": "optional"
                              }
                            }
                          },
                          "BooleanAttribute": {
                            "fields": {
                              "attributeName": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "attributeValue": {
                                "type": "bool",
                                "id": 2,
                                "rule": "optional"
                              }
                            }
                          },
                          "Text": {
                            "fields": {
                              "keywords": {
                                "type": "string",
                                "id": 1,
                                "rule": "repeated"
                              }
                            }
                          },
                          "ItemsForTax": {
                            "fields": {
                              "taxIds": {
                                "type": "string",
                                "id": 1,
                                "rule": "repeated"
                              }
                            }
                          },
                          "ItemsForModifierList": {
                            "fields": {
                              "modifierListIds": {
                                "type": "string",
                                "id": 1,
                                "rule": "repeated"
                              }
                            }
                          },
                          "ItemsForItemOptions": {
                            "fields": {
                              "itemOptionIds": {
                                "type": "string",
                                "id": 1,
                                "rule": "repeated"
                              }
                            }
                          },
                          "ItemVariationsForItemOptionValues": {
                            "fields": {
                              "itemOptionValueIds": {
                                "type": "string",
                                "id": 1,
                                "rule": "repeated"
                              }
                            }
                          },
                          "PricingObjectsForProducts": {
                            "fields": {
                              "productIds": {
                                "type": "string",
                                "id": 1,
                                "rule": "repeated"
                              },
                              "pricingRuleIds": {
                                "type": "string",
                                "id": 2,
                                "rule": "repeated"
                              },
                              "includeProducts": {
                                "type": "bool",
                                "id": 3,
                                "rule": "optional"
                              },
                              "includeDiscountObjects": {
                                "type": "bool",
                                "id": 4,
                                "rule": "optional"
                              },
                              "includeTaxObjects": {
                                "type": "bool",
                                "id": 5,
                                "rule": "optional"
                              },
                              "includeCustomAmountObjects": {
                                "type": "bool",
                                "id": 6,
                                "rule": "optional",
                                "options": {
                                  "default": true
                                }
                              },
                              "includeAllProductObjects": {
                                "type": "bool",
                                "id": 7,
                                "rule": "optional",
                                "options": {
                                  "default": true
                                }
                              },
                              "includeLineItemTypes": {
                                "type": "squareup.connect.v2.merchant_catalog.resources.CatalogProductSetLineItemType",
                                "id": 8,
                                "rule": "repeated"
                              },
                              "includeCategoryAncestors": {
                                "type": "bool",
                                "id": 9,
                                "rule": "optional",
                                "options": {
                                  "default": false
                                }
                              },
                              "enableProductIdRetrieval": {
                                "type": "bool",
                                "id": 10,
                                "rule": "optional",
                                "options": {
                                  "default": false
                                }
                              },
                              "unitToken": {
                                "type": "string",
                                "id": 11,
                                "rule": "optional"
                              }
                            }
                          },
                          "CheckoutLinksForItems": {
                            "fields": {
                              "itemIds": {
                                "type": "string",
                                "id": 1,
                                "rule": "repeated"
                              }
                            }
                          },
                          "FilteredItems": {
                            "fields": {
                              "textFilter": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "searchVendorCode": {
                                "type": "bool",
                                "id": 9,
                                "rule": "optional"
                              },
                              "categoryIds": {
                                "type": "string",
                                "id": 2,
                                "rule": "repeated"
                              },
                              "stockLevels": {
                                "type": "squareup.connect.v2.merchant_catalog.resources.CatalogQuery.FilteredItems.StockLevel",
                                "id": 3,
                                "rule": "repeated"
                              },
                              "enabledLocationIds": {
                                "type": "string",
                                "id": 4,
                                "rule": "repeated"
                              },
                              "vendorIds": {
                                "type": "string",
                                "id": 5,
                                "rule": "repeated"
                              },
                              "productTypes": {
                                "type": "squareup.connect.v2.merchant_catalog.resources.CatalogItemProductType",
                                "id": 6,
                                "rule": "repeated"
                              },
                              "customAttributeFilters": {
                                "type": "squareup.connect.v2.merchant_catalog.resources.CatalogQuery.FilteredItems.CustomAttributeFilter",
                                "id": 7,
                                "rule": "repeated"
                              },
                              "doesNotExist": {
                                "type": "squareup.connect.v2.merchant_catalog.resources.CatalogQuery.FilteredItems.NullableAttribute",
                                "id": 8,
                                "rule": "repeated"
                              },
                              "sortOrder": {
                                "type": "squareup.connect.v2.common.SortOrder",
                                "id": 10,
                                "rule": "optional",
                                "options": {
                                  "default": "ASC"
                                }
                              }
                            },
                            "nested": {
                              "StockLevel": {
                                "values": {
                                  "STOCK_LEVEL_DO_NOT_USE": 0,
                                  "OUT": 1,
                                  "LOW": 2
                                }
                              },
                              "CustomAttributeFilter": {
                                "fields": {
                                  "filterType": {
                                    "type": "squareup.connect.v2.merchant_catalog.resources.CatalogQuery.FilteredItems.CustomAttributeFilter.FilterType",
                                    "id": 1,
                                    "rule": "optional"
                                  },
                                  "customAttributeDefinitionIds": {
                                    "type": "string",
                                    "id": 2,
                                    "rule": "repeated"
                                  },
                                  "customAttributeValueExact": {
                                    "type": "string",
                                    "id": 3,
                                    "rule": "optional"
                                  },
                                  "customAttributeValuePrefix": {
                                    "type": "string",
                                    "id": 4,
                                    "rule": "optional"
                                  },
                                  "customAttributeMinValue": {
                                    "type": "string",
                                    "id": 5,
                                    "rule": "optional"
                                  },
                                  "customAttributeMaxValue": {
                                    "type": "string",
                                    "id": 6,
                                    "rule": "optional"
                                  }
                                },
                                "nested": {
                                  "FilterType": {
                                    "values": {
                                      "CUSTOM_ATTRIBUTE_FILTER_TYPE_DO_NOT_USE": 0,
                                      "EXACT": 1,
                                      "PREFIX": 2,
                                      "RANGE": 3,
                                      "BOOLEAN": 4
                                    }
                                  }
                                }
                              },
                              "NullableAttribute": {
                                "values": {
                                  "VENDOR_TOKEN": 1
                                }
                              }
                            }
                          },
                          "CustomAttributeUsage": {
                            "fields": {
                              "customAttributeDefinitionIds": {
                                "type": "string",
                                "id": 1,
                                "rule": "repeated"
                              },
                              "hasValue": {
                                "type": "bool",
                                "id": 2,
                                "rule": "optional",
                                "options": {
                                  "default": true
                                }
                              }
                            }
                          },
                          "LegacyIdsAtLocation": {
                            "fields": {
                              "locationId": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "legacyIds": {
                                "type": "string",
                                "id": 2,
                                "rule": "repeated"
                              }
                            }
                          },
                          "LegacyIds": {
                            "fields": {
                              "legacyIdsAtLocation": {
                                "type": "squareup.connect.v2.merchant_catalog.resources.CatalogQuery.LegacyIdsAtLocation",
                                "id": 11,
                                "rule": "repeated"
                              }
                            }
                          },
                          "DoesNotExist": {
                            "fields": {
                              "attributeName": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              }
                            }
                          },
                          "PresentAtLocations": {
                            "fields": {
                              "locationIds": {
                                "type": "string",
                                "id": 1,
                                "rule": "repeated"
                              }
                            }
                          }
                        }
                      },
                      "CatalogModifierOverride": {
                        "fields": {
                          "modifierId": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "onByDefault": {
                            "type": "bool",
                            "id": 2,
                            "rule": "optional"
                          },
                          "hiddenOnline": {
                            "type": "bool",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "CatalogItemModifierListInfo": {
                        "fields": {
                          "modifierListId": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "visibility": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogVisibility",
                            "id": 2,
                            "rule": "optional",
                            "options": {
                              "default": "PRIVATE"
                            }
                          },
                          "modifierOverrides": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogModifierOverride",
                            "id": 3,
                            "rule": "repeated"
                          },
                          "minSelectedModifiers": {
                            "type": "int32",
                            "id": 4,
                            "rule": "optional",
                            "options": {
                              "default": -1
                            }
                          },
                          "maxSelectedModifiers": {
                            "type": "int32",
                            "id": 5,
                            "rule": "optional",
                            "options": {
                              "default": -1
                            }
                          },
                          "enabled": {
                            "type": "bool",
                            "id": 6,
                            "rule": "optional",
                            "options": {
                              "default": true
                            }
                          },
                          "hiddenFromCustomer": {
                            "type": "bool",
                            "id": 7,
                            "rule": "optional",
                            "options": {
                              "default": false
                            }
                          },
                          "ordinal": {
                            "type": "int32",
                            "id": 8,
                            "rule": "optional"
                          }
                        }
                      },
                      "CatalogItemOptionForItem": {
                        "fields": {
                          "itemOptionId": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "CatalogObjectCategory": {
                        "fields": {
                          "id": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "ordinal": {
                            "type": "int64",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "CatalogEcomSeoData": {
                        "fields": {
                          "pageTitle": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "pageDescription": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "permalink": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "CatalogOpenGraphData": {
                        "fields": {
                          "linkTitle": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "linkDescription": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "CatalogItem": {
                        "fields": {
                          "name": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "description": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "abbreviation": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "labelColor": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          },
                          "isTaxable": {
                            "type": "bool",
                            "id": 5,
                            "rule": "optional"
                          },
                          "visibility": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogVisibility",
                            "id": 6,
                            "rule": "optional",
                            "options": {
                              "default": "PRIVATE"
                            }
                          },
                          "availableOnline": {
                            "type": "bool",
                            "id": 7,
                            "rule": "optional"
                          },
                          "availableForPickup": {
                            "type": "bool",
                            "id": 8,
                            "rule": "optional"
                          },
                          "availableElectronically": {
                            "type": "bool",
                            "id": 9,
                            "rule": "optional"
                          },
                          "categoryId": {
                            "type": "string",
                            "id": 10,
                            "rule": "optional"
                          },
                          "buyerFacingName": {
                            "type": "string",
                            "id": 11,
                            "rule": "optional"
                          },
                          "ordinal": {
                            "type": "int32",
                            "id": 12,
                            "rule": "optional"
                          },
                          "taxIds": {
                            "type": "string",
                            "id": 13,
                            "rule": "repeated"
                          },
                          "modifierListInfo": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogItemModifierListInfo",
                            "id": 14,
                            "rule": "repeated"
                          },
                          "imageUrl": {
                            "type": "string",
                            "id": 15,
                            "rule": "optional"
                          },
                          "variations": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogObject",
                            "id": 16,
                            "rule": "repeated"
                          },
                          "productType": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogItemProductType",
                            "id": 17,
                            "rule": "optional",
                            "options": {
                              "default": "REGULAR"
                            }
                          },
                          "skipModifierScreen": {
                            "type": "bool",
                            "id": 18,
                            "rule": "optional"
                          },
                          "itemOptions": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogItemOptionForItem",
                            "id": 19,
                            "rule": "repeated"
                          },
                          "ecomUri": {
                            "type": "string",
                            "id": 20,
                            "rule": "optional"
                          },
                          "ecomImageUris": {
                            "type": "string",
                            "id": 21,
                            "rule": "repeated"
                          },
                          "ecomAvailable": {
                            "type": "bool",
                            "id": 22,
                            "rule": "optional"
                          },
                          "onlineStoreData": {
                            "type": "string",
                            "id": 23,
                            "rule": "optional"
                          },
                          "ecomBuyButtonText": {
                            "type": "string",
                            "id": 24,
                            "rule": "optional"
                          },
                          "ecomVisibility": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.EcomVisibility",
                            "id": 25,
                            "rule": "optional",
                            "options": {
                              "default": "UNINDEXED"
                            }
                          },
                          "imageIds": {
                            "type": "string",
                            "id": 26,
                            "rule": "repeated"
                          },
                          "legacyTaxIds": {
                            "type": "string",
                            "id": 27,
                            "rule": "repeated"
                          },
                          "sortName": {
                            "type": "string",
                            "id": 28,
                            "rule": "optional"
                          },
                          "event": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.Event",
                            "id": 30,
                            "rule": "optional"
                          },
                          "categories": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogObjectCategory",
                            "id": 31,
                            "rule": "repeated"
                          },
                          "pickupFulfillmentPreferencesId": {
                            "type": "string",
                            "id": 33,
                            "rule": "optional"
                          },
                          "deliveryFulfillmentPreferencesId": {
                            "type": "string",
                            "id": 34,
                            "rule": "optional"
                          },
                          "descriptionHtml": {
                            "type": "string",
                            "id": 35,
                            "rule": "optional"
                          },
                          "descriptionPlaintext": {
                            "type": "string",
                            "id": 36,
                            "rule": "optional"
                          },
                          "kitchenName": {
                            "type": "string",
                            "id": 37,
                            "rule": "optional"
                          },
                          "ecomAllowOrderItemQuantities": {
                            "type": "bool",
                            "id": 38,
                            "rule": "optional",
                            "options": {
                              "default": false
                            }
                          },
                          "ecomOrderItemMaxQuantity": {
                            "type": "int32",
                            "id": 39,
                            "rule": "optional"
                          },
                          "channels": {
                            "type": "string",
                            "id": 40,
                            "rule": "repeated"
                          },
                          "locationOverrides": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.ItemLocationOverrides",
                            "id": 41,
                            "rule": "repeated"
                          },
                          "shippingFulfillmentPreferencesId": {
                            "type": "string",
                            "id": 42,
                            "rule": "optional"
                          },
                          "dineInFulfillmentPreferencesId": {
                            "type": "string",
                            "id": 43,
                            "rule": "optional"
                          },
                          "isArchived": {
                            "type": "bool",
                            "id": 44,
                            "rule": "optional",
                            "options": {
                              "default": false
                            }
                          },
                          "requiresSubscriptionToSell": {
                            "type": "bool",
                            "id": 45,
                            "rule": "optional",
                            "options": {
                              "default": false
                            }
                          },
                          "ageRestrictionId": {
                            "type": "string",
                            "id": 46,
                            "rule": "optional"
                          },
                          "ecomSeoData": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogEcomSeoData",
                            "id": 47,
                            "rule": "optional"
                          },
                          "posDisplayName": {
                            "type": "string",
                            "id": 48,
                            "rule": "optional"
                          },
                          "foodAndBeverageDetails": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogItem.FoodAndBeverageDetails",
                            "id": 49,
                            "rule": "optional"
                          },
                          "comboTypeDetails": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogItem.CatalogItemComboTypeDetails",
                            "id": 50,
                            "rule": "optional"
                          },
                          "reportingCategory": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogObjectCategory",
                            "id": 51,
                            "rule": "optional"
                          },
                          "openGraphData": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogOpenGraphData",
                            "id": 52,
                            "rule": "optional"
                          },
                          "customShippingBoxId": {
                            "type": "string",
                            "id": 53,
                            "rule": "optional"
                          },
                          "taxCategoryId": {
                            "type": "string",
                            "id": 54,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "FoodAndBeverageDetails": {
                            "fields": {
                              "calorieCount": {
                                "type": "int32",
                                "id": 1,
                                "rule": "optional"
                              },
                              "dietaryPreferences": {
                                "type": "squareup.connect.v2.merchant_catalog.resources.CatalogItem.FoodAndBeverageDetails.DietaryPreference",
                                "id": 2,
                                "rule": "repeated"
                              },
                              "ingredients": {
                                "type": "squareup.connect.v2.merchant_catalog.resources.CatalogItem.FoodAndBeverageDetails.Ingredient",
                                "id": 3,
                                "rule": "repeated"
                              }
                            },
                            "nested": {
                              "DietaryPreferenceType": {
                                "values": {
                                  "DIETARY_PREFERENCE_TYPE_DO_NOT_USE": 0,
                                  "STANDARD": 1,
                                  "CUSTOM": 2
                                }
                              },
                              "DietaryPreference": {
                                "fields": {
                                  "type": {
                                    "type": "squareup.connect.v2.merchant_catalog.resources.CatalogItem.FoodAndBeverageDetails.DietaryPreferenceType",
                                    "id": 1,
                                    "rule": "optional"
                                  },
                                  "standardName": {
                                    "type": "squareup.connect.v2.merchant_catalog.resources.CatalogItem.FoodAndBeverageDetails.DietaryPreference.StandardDietaryPreference",
                                    "id": 2,
                                    "rule": "optional"
                                  },
                                  "customName": {
                                    "type": "string",
                                    "id": 3,
                                    "rule": "optional"
                                  }
                                },
                                "nested": {
                                  "StandardDietaryPreference": {
                                    "values": {
                                      "STANDARD_DIETARY_PREFERENCE_DO_NOT_USE": 0,
                                      "DAIRY_FREE": 1,
                                      "GLUTEN_FREE": 2,
                                      "HALAL": 3,
                                      "KOSHER": 4,
                                      "NUT_FREE": 5,
                                      "VEGAN": 6,
                                      "VEGETARIAN": 7
                                    }
                                  }
                                }
                              },
                              "Ingredient": {
                                "fields": {
                                  "type": {
                                    "type": "squareup.connect.v2.merchant_catalog.resources.CatalogItem.FoodAndBeverageDetails.DietaryPreferenceType",
                                    "id": 1,
                                    "rule": "optional"
                                  },
                                  "standardName": {
                                    "type": "squareup.connect.v2.merchant_catalog.resources.CatalogItem.FoodAndBeverageDetails.Ingredient.StandardIngredient",
                                    "id": 2,
                                    "rule": "optional"
                                  },
                                  "customName": {
                                    "type": "string",
                                    "id": 3,
                                    "rule": "optional"
                                  }
                                },
                                "nested": {
                                  "StandardIngredient": {
                                    "values": {
                                      "STANDARD_INGREDIENT_DO_NOT_USE": 0,
                                      "CELERY": 1,
                                      "CRUSTACEANS": 2,
                                      "EGGS": 3,
                                      "FISH": 4,
                                      "GLUTEN": 5,
                                      "LUPIN": 6,
                                      "MILK": 7,
                                      "MOLLUSCS": 8,
                                      "MUSTARD": 9,
                                      "PEANUTS": 10,
                                      "SESAME": 11,
                                      "SOY": 12,
                                      "SULPHITES": 13,
                                      "TREE_NUTS": 14
                                    }
                                  }
                                }
                              }
                            }
                          },
                          "CatalogItemComboTypeDetails": {
                            "fields": {
                              "slots": {
                                "type": "squareup.connect.v2.merchant_catalog.resources.CatalogItem.CatalogItemComboTypeDetails.CatalogComboSlot",
                                "id": 1,
                                "rule": "repeated"
                              }
                            },
                            "nested": {
                              "CatalogComboSlot": {
                                "fields": {
                                  "uid": {
                                    "type": "string",
                                    "id": 1,
                                    "rule": "optional"
                                  },
                                  "name": {
                                    "type": "string",
                                    "id": 2,
                                    "rule": "optional"
                                  },
                                  "numSelections": {
                                    "type": "uint32",
                                    "id": 3,
                                    "rule": "optional"
                                  },
                                  "itemId": {
                                    "type": "string",
                                    "id": 4,
                                    "rule": "optional"
                                  },
                                  "categoryId": {
                                    "type": "string",
                                    "id": 5,
                                    "rule": "optional"
                                  },
                                  "defaultItemVariationId": {
                                    "type": "string",
                                    "id": 6,
                                    "rule": "optional"
                                  }
                                }
                              }
                            }
                          }
                        }
                      },
                      "ItemLocationOverrides": {
                        "fields": {
                          "locationId": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "ordinal": {
                            "type": "int32",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "ItemVariationLocationOverrides": {
                        "fields": {
                          "locationId": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "priceMoney": {
                            "type": "squareup.connect.v2.common.Money",
                            "id": 2,
                            "rule": "optional"
                          },
                          "pricingType": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogPricingType",
                            "id": 3,
                            "rule": "optional"
                          },
                          "trackInventory": {
                            "type": "bool",
                            "id": 4,
                            "rule": "optional"
                          },
                          "inventoryAlertType": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.InventoryAlertType",
                            "id": 5,
                            "rule": "optional",
                            "options": {
                              "default": "NONE"
                            }
                          },
                          "inventoryAlertThreshold": {
                            "type": "int64",
                            "id": 6,
                            "rule": "optional"
                          },
                          "priceDescription": {
                            "type": "string",
                            "id": 7,
                            "rule": "optional"
                          },
                          "resourceTokens": {
                            "type": "string",
                            "id": 8,
                            "rule": "repeated"
                          },
                          "soldOut": {
                            "type": "bool",
                            "id": 9,
                            "rule": "optional"
                          },
                          "soldOutValidUntil": {
                            "type": "string",
                            "id": 10,
                            "rule": "optional"
                          },
                          "contractTemplateTokens": {
                            "type": "string",
                            "id": 11,
                            "rule": "repeated"
                          }
                        }
                      },
                      "CatalogItemOptionValueForItemVariation": {
                        "fields": {
                          "itemOptionId": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "itemOptionValueId": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "Intermission": {
                        "fields": {
                          "startOffset": {
                            "type": "uint32",
                            "id": 1,
                            "rule": "optional"
                          },
                          "endOffset": {
                            "type": "uint32",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "CatalogStockConversion": {
                        "fields": {
                          "stockableItemVariationId": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "stockableQuantity": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "nonstockableQuantity": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "ItemVariationWeight": {
                        "fields": {
                          "amount": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "weightUnit": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogItemVariationWeightUnit",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "CatalogBundle": {
                        "fields": {
                          "quantityRatio": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.QuantityRatio",
                            "id": 1,
                            "rule": "optional"
                          },
                          "components": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogBundleComponent",
                            "id": 2,
                            "rule": "repeated"
                          }
                        }
                      },
                      "CatalogBundleComponent": {
                        "fields": {
                          "uid": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "quantityRatio": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.QuantityRatio",
                            "id": 2,
                            "rule": "optional"
                          },
                          "variationId": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "ServiceCost": {
                        "fields": {
                          "pricingType": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.ServiceCostType",
                            "id": 1,
                            "rule": "optional"
                          },
                          "amountFlat": {
                            "type": "squareup.connect.v2.common.Money",
                            "id": 2,
                            "rule": "optional"
                          },
                          "amountPercent": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "CatalogItemVariation": {
                        "fields": {
                          "itemId": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "name": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "sku": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "upc": {
                            "type": "string",
                            "id": 13,
                            "rule": "optional"
                          },
                          "ordinal": {
                            "type": "int32",
                            "id": 4,
                            "rule": "optional"
                          },
                          "pricingType": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogPricingType",
                            "id": 5,
                            "rule": "optional"
                          },
                          "priceMoney": {
                            "type": "squareup.connect.v2.common.Money",
                            "id": 6,
                            "rule": "optional"
                          },
                          "locationOverrides": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.ItemVariationLocationOverrides",
                            "id": 12,
                            "rule": "repeated"
                          },
                          "trackInventory": {
                            "type": "bool",
                            "id": 7,
                            "rule": "optional"
                          },
                          "inventoryAlertType": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.InventoryAlertType",
                            "id": 8,
                            "rule": "optional",
                            "options": {
                              "default": "NONE"
                            }
                          },
                          "inventoryAlertThreshold": {
                            "type": "int64",
                            "id": 9,
                            "rule": "optional"
                          },
                          "buyerFacingName": {
                            "type": "string",
                            "id": 10,
                            "rule": "optional"
                          },
                          "userData": {
                            "type": "string",
                            "id": 11,
                            "rule": "optional"
                          },
                          "serviceDuration": {
                            "type": "int64",
                            "id": 14,
                            "rule": "optional"
                          },
                          "priceDescription": {
                            "type": "string",
                            "id": 15,
                            "rule": "optional"
                          },
                          "availableForBooking": {
                            "type": "bool",
                            "id": 16,
                            "rule": "optional"
                          },
                          "noShowFee": {
                            "type": "squareup.connect.v2.common.Money",
                            "id": 17,
                            "rule": "optional"
                          },
                          "transitionTime": {
                            "type": "int64",
                            "id": 18,
                            "rule": "optional"
                          },
                          "itemOptionValues": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogItemOptionValueForItemVariation",
                            "id": 22,
                            "rule": "repeated"
                          },
                          "measurementUnitId": {
                            "type": "string",
                            "id": 21,
                            "rule": "optional"
                          },
                          "intermissions": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.Intermission",
                            "id": 23,
                            "rule": "repeated"
                          },
                          "sellable": {
                            "type": "bool",
                            "id": 24,
                            "rule": "optional",
                            "options": {
                              "default": true
                            }
                          },
                          "stockable": {
                            "type": "bool",
                            "id": 25,
                            "rule": "optional",
                            "options": {
                              "default": true
                            }
                          },
                          "imageIds": {
                            "type": "string",
                            "id": 27,
                            "rule": "repeated"
                          },
                          "teamMemberIds": {
                            "type": "string",
                            "id": 28,
                            "rule": "repeated"
                          },
                          "compositionId": {
                            "type": "string",
                            "id": 26,
                            "rule": "optional"
                          },
                          "stockableConversion": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogStockConversion",
                            "id": 29,
                            "rule": "optional"
                          },
                          "subscriptionPlanIds": {
                            "type": "string",
                            "id": 30,
                            "rule": "repeated"
                          },
                          "kitchenName": {
                            "type": "string",
                            "id": 31,
                            "rule": "optional"
                          },
                          "contractTemplateTokens": {
                            "type": "string",
                            "id": 32,
                            "rule": "repeated"
                          },
                          "defaultUnitCost": {
                            "type": "squareup.connect.v2.common.Money",
                            "id": 33,
                            "rule": "optional"
                          },
                          "channels": {
                            "type": "string",
                            "id": 34,
                            "rule": "repeated"
                          },
                          "itemVariationVendorInfoIds": {
                            "type": "string",
                            "id": 35,
                            "rule": "repeated"
                          },
                          "itemVariationVendorInfos": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogObject",
                            "id": 38,
                            "rule": "repeated"
                          },
                          "bundle": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogBundle",
                            "id": 36,
                            "rule": "optional"
                          },
                          "weight": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.ItemVariationWeight",
                            "id": 37,
                            "rule": "optional"
                          },
                          "creditPackageInfo": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CreditPackageInfo",
                            "id": 40,
                            "rule": "optional"
                          },
                          "salePrices": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogObject",
                            "id": 42,
                            "rule": "repeated"
                          },
                          "serviceCost": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.ServiceCost",
                            "id": 43,
                            "rule": "optional"
                          },
                          "vendorInformation": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogItemVariationVendorInformation",
                            "id": 44,
                            "rule": "repeated"
                          },
                          "noShowFeePercentage": {
                            "type": "int32",
                            "id": 45,
                            "rule": "optional"
                          }
                        }
                      },
                      "CatalogItemVariationVendorInformation": {
                        "fields": {
                          "vendorId": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "vendorCode": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "unitCostMoney": {
                            "type": "squareup.connect.v2.common.Money",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "CreditPackageInfo": {
                        "fields": {
                          "validityDuration": {
                            "type": "string",
                            "id": 39,
                            "rule": "optional"
                          },
                          "redemptionPolicies": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogObject",
                            "id": 40,
                            "rule": "repeated"
                          }
                        }
                      },
                      "CatalogItemVariationVendorInfo": {
                        "fields": {
                          "name": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "ordinal": {
                            "type": "int32",
                            "id": 2,
                            "rule": "optional"
                          },
                          "sku": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "priceMoney": {
                            "type": "squareup.connect.v2.common.Money",
                            "id": 4,
                            "rule": "optional"
                          },
                          "itemVariationId": {
                            "type": "string",
                            "id": 5,
                            "rule": "optional"
                          },
                          "vendorId": {
                            "type": "string",
                            "id": 6,
                            "rule": "optional"
                          }
                        }
                      },
                      "QuantityRatio": {
                        "fields": {
                          "quantity": {
                            "type": "uint32",
                            "id": 1,
                            "rule": "optional"
                          },
                          "quantityDenominator": {
                            "type": "uint32",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "CatalogComposition": {
                        "fields": {
                          "quantity": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.QuantityRatio",
                            "id": 1,
                            "rule": "optional"
                          },
                          "components": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogObject",
                            "id": 2,
                            "rule": "repeated"
                          },
                          "compositionType": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CompositionType",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "CatalogComponent": {
                        "fields": {
                          "quantity": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.QuantityRatio",
                            "id": 1,
                            "rule": "optional"
                          },
                          "variationId": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "compositionId": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "StraightFireType": {
                        "values": {
                          "UNKNOWN_STRAIGHT_FIRE": 0,
                          "NEVER_STRAIGHT_FIRE": 1,
                          "ALWAYS_STRAIGHT_FIRE": 2
                        }
                      },
                      "CategoryLocationOverrides": {
                        "fields": {
                          "locationId": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "straightfire": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.StraightFireType",
                            "id": 2,
                            "rule": "optional"
                          },
                          "ordinal": {
                            "type": "int32",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "CatalogCategory": {
                        "fields": {
                          "name": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "ordinal": {
                            "type": "int32",
                            "id": 2,
                            "rule": "optional"
                          },
                          "abbreviation": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "labelColor": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          },
                          "imageIds": {
                            "type": "string",
                            "id": 5,
                            "rule": "repeated"
                          },
                          "locationOverrides": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CategoryLocationOverrides",
                            "id": 6,
                            "rule": "repeated"
                          },
                          "categoryType": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogCategoryType",
                            "id": 7,
                            "rule": "optional"
                          },
                          "parentCategory": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogObjectCategory",
                            "id": 8,
                            "rule": "optional"
                          },
                          "isTopLevel": {
                            "type": "bool",
                            "id": 9,
                            "rule": "optional"
                          },
                          "channels": {
                            "type": "string",
                            "id": 11,
                            "rule": "repeated"
                          },
                          "itemCount": {
                            "type": "int64",
                            "id": 13,
                            "rule": "optional"
                          },
                          "categoryCount": {
                            "type": "int64",
                            "id": 14,
                            "rule": "optional"
                          },
                          "availabilityPeriodIds": {
                            "type": "string",
                            "id": 15,
                            "rule": "repeated"
                          },
                          "onlineVisibility": {
                            "type": "bool",
                            "id": 16,
                            "rule": "optional"
                          },
                          "rootCategory": {
                            "type": "string",
                            "id": 18,
                            "rule": "optional"
                          },
                          "ecomSeoData": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogEcomSeoData",
                            "id": 19,
                            "rule": "optional"
                          },
                          "pathToRoot": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CategoryPathToRootNode",
                            "id": 20,
                            "rule": "repeated"
                          },
                          "openGraphData": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogOpenGraphData",
                            "id": 21,
                            "rule": "optional"
                          },
                          "migratedFromSquareOnline": {
                            "type": "bool",
                            "id": 22,
                            "rule": "optional"
                          }
                        }
                      },
                      "CategoryPathToRootNode": {
                        "fields": {
                          "categoryId": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "categoryName": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "CatalogTax": {
                        "fields": {
                          "name": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "calculationPhase": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.TaxCalculationPhase",
                            "id": 2,
                            "rule": "optional",
                            "options": {
                              "default": "TAX_SUBTOTAL_PHASE"
                            }
                          },
                          "inclusionType": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.TaxInclusionType",
                            "id": 3,
                            "rule": "optional",
                            "options": {
                              "default": "ADDITIVE"
                            }
                          },
                          "percentage": {
                            "type": "string",
                            "id": 5,
                            "rule": "optional"
                          },
                          "appliesToCustomAmounts": {
                            "type": "bool",
                            "id": 6,
                            "rule": "optional",
                            "options": {
                              "default": true
                            }
                          },
                          "enabled": {
                            "type": "bool",
                            "id": 7,
                            "rule": "optional",
                            "options": {
                              "default": true
                            }
                          },
                          "taxTypeId": {
                            "type": "string",
                            "id": 8,
                            "rule": "optional"
                          },
                          "taxTypeName": {
                            "type": "string",
                            "id": 9,
                            "rule": "optional"
                          },
                          "amount": {
                            "type": "squareup.connect.v2.common.Money",
                            "id": 10,
                            "rule": "optional"
                          },
                          "appliesToProductSetId": {
                            "type": "string",
                            "id": 11,
                            "rule": "optional"
                          }
                        }
                      },
                      "CatalogTaxExemption": {
                        "fields": {
                          "name": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "diningOptionIds": {
                            "type": "string",
                            "id": 2,
                            "rule": "repeated"
                          },
                          "maxTotalAmountMoney": {
                            "type": "squareup.connect.v2.common.Money",
                            "id": 3,
                            "rule": "optional"
                          },
                          "minItemPriceMoney": {
                            "type": "squareup.connect.v2.common.Money",
                            "id": 4,
                            "rule": "optional"
                          },
                          "maxItemPriceMoney": {
                            "type": "squareup.connect.v2.common.Money",
                            "id": 5,
                            "rule": "optional"
                          },
                          "taxId": {
                            "type": "string",
                            "id": 6,
                            "rule": "optional"
                          },
                          "exemptProductSetId": {
                            "type": "string",
                            "id": 7,
                            "rule": "optional"
                          },
                          "legacyItemConfigurationMatchAll": {
                            "type": "bool",
                            "id": 8,
                            "rule": "optional"
                          },
                          "legacyItemIds": {
                            "type": "string",
                            "id": 9,
                            "rule": "repeated"
                          },
                          "appliesToCustomAmounts": {
                            "type": "bool",
                            "id": 10,
                            "rule": "optional"
                          },
                          "hasDiningOptionPredicate": {
                            "type": "bool",
                            "id": 11,
                            "rule": "optional"
                          }
                        }
                      },
                      "CatalogTaxCategory": {
                        "fields": {
                          "name": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "DiningOptionLocationOverrides": {
                        "fields": {
                          "locationId": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "ordinal": {
                            "type": "int32",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "CatalogDiningOption": {
                        "fields": {
                          "name": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "ordinal": {
                            "type": "int32",
                            "id": 2,
                            "rule": "optional"
                          },
                          "locationOverrides": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.DiningOptionLocationOverrides",
                            "id": 3,
                            "rule": "repeated"
                          }
                        }
                      },
                      "CatalogDiscount": {
                        "fields": {
                          "name": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "discountType": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogDiscountType",
                            "id": 2,
                            "rule": "optional",
                            "options": {
                              "default": "FIXED_PERCENTAGE"
                            }
                          },
                          "percentage": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "amountMoney": {
                            "type": "squareup.connect.v2.common.Money",
                            "id": 4,
                            "rule": "optional"
                          },
                          "pinRequired": {
                            "type": "bool",
                            "id": 5,
                            "rule": "optional",
                            "options": {
                              "default": false
                            }
                          },
                          "labelColor": {
                            "type": "string",
                            "id": 6,
                            "rule": "optional"
                          },
                          "applicationMethod": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogDiscountApplicationMethod",
                            "id": 7,
                            "rule": "optional",
                            "options": {
                              "default": "MANUALLY_APPLIED"
                            }
                          },
                          "compOrdinal": {
                            "type": "int32",
                            "id": 8,
                            "rule": "optional"
                          },
                          "modifyTaxBasis": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogDiscountModifyTaxBasis",
                            "id": 9,
                            "rule": "optional",
                            "options": {
                              "default": "MODIFY_TAX_BASIS"
                            }
                          },
                          "maximumAmountMoney": {
                            "type": "squareup.connect.v2.common.Money",
                            "id": 10,
                            "rule": "optional"
                          }
                        }
                      },
                      "CatalogSalePrice": {
                        "fields": {
                          "itemVariationId": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "salePriceType": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogSalePriceType",
                            "id": 3,
                            "rule": "optional",
                            "options": {
                              "default": "SALE_PRICE_TYPE_FIXED_AMOUNT"
                            }
                          },
                          "percentage": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          },
                          "amountMoney": {
                            "type": "squareup.connect.v2.common.Money",
                            "id": 5,
                            "rule": "optional"
                          },
                          "validFromDate": {
                            "type": "string",
                            "id": 6,
                            "rule": "optional"
                          },
                          "validUntilDate": {
                            "type": "string",
                            "id": 7,
                            "rule": "optional"
                          }
                        }
                      },
                      "CatalogModifier": {
                        "fields": {
                          "name": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "priceMoney": {
                            "type": "squareup.connect.v2.common.Money",
                            "id": 2,
                            "rule": "optional"
                          },
                          "onByDefault": {
                            "type": "bool",
                            "id": 3,
                            "rule": "optional",
                            "options": {
                              "default": false
                            }
                          },
                          "ordinal": {
                            "type": "int32",
                            "id": 4,
                            "rule": "optional"
                          },
                          "modifierListId": {
                            "type": "string",
                            "id": 5,
                            "rule": "optional"
                          },
                          "locationOverrides": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.ModifierLocationOverrides",
                            "id": 7,
                            "rule": "repeated"
                          },
                          "kitchenName": {
                            "type": "string",
                            "id": 8,
                            "rule": "optional"
                          },
                          "imageId": {
                            "type": "string",
                            "id": 9,
                            "rule": "optional"
                          }
                        }
                      },
                      "ModifierLocationOverrides": {
                        "fields": {
                          "locationId": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "priceMoney": {
                            "type": "squareup.connect.v2.common.Money",
                            "id": 2,
                            "rule": "optional"
                          },
                          "soldOut": {
                            "type": "bool",
                            "id": 9,
                            "rule": "optional"
                          },
                          "soldOutValidUntil": {
                            "type": "string",
                            "id": 10,
                            "rule": "optional"
                          }
                        }
                      },
                      "CatalogModifierList": {
                        "fields": {
                          "name": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "ordinal": {
                            "type": "int32",
                            "id": 3,
                            "rule": "optional"
                          },
                          "selectionType": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogModifierListSelectionType",
                            "id": 4,
                            "rule": "optional",
                            "options": {
                              "default": "SINGLE"
                            }
                          },
                          "modifiers": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogObject",
                            "id": 5,
                            "rule": "repeated"
                          },
                          "imageIds": {
                            "type": "string",
                            "id": 6,
                            "rule": "repeated"
                          },
                          "allowQuantities": {
                            "type": "bool",
                            "id": 7,
                            "rule": "optional",
                            "options": {
                              "default": false
                            }
                          },
                          "maxQuantity": {
                            "type": "int32",
                            "id": 8,
                            "rule": "optional",
                            "options": {
                              "default": 10
                            }
                          },
                          "isConversational": {
                            "type": "bool",
                            "id": 9,
                            "rule": "optional",
                            "options": {
                              "default": false
                            }
                          },
                          "modifierType": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogModifierListModifierType",
                            "id": 10,
                            "rule": "optional",
                            "options": {
                              "default": "LIST"
                            }
                          },
                          "maxLength": {
                            "type": "int32",
                            "id": 11,
                            "rule": "optional",
                            "options": {
                              "default": 150
                            }
                          },
                          "textRequired": {
                            "type": "bool",
                            "id": 12,
                            "rule": "optional",
                            "options": {
                              "default": false
                            }
                          },
                          "internalName": {
                            "type": "string",
                            "id": 13,
                            "rule": "optional"
                          }
                        }
                      },
                      "CatalogImage": {
                        "fields": {
                          "name": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "url": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "caption": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "photoStudioOrderId": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          }
                        }
                      },
                      "ImageFileData": {
                        "fields": {
                          "body": {
                            "type": "bytes",
                            "id": 1,
                            "rule": "optional"
                          },
                          "contentType": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "CatalogV1Id": {
                        "fields": {
                          "catalogV1Id": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "locationId": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "CatalogCustomAttributeValue": {
                        "fields": {
                          "name": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "stringValue": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "intValue": {
                            "type": "int64",
                            "id": 3,
                            "rule": "optional"
                          },
                          "customAttributeDefinitionId": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          },
                          "type": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogCustomAttributeDefinition.Type",
                            "id": 5,
                            "rule": "optional"
                          },
                          "numberValue": {
                            "type": "string",
                            "id": 6,
                            "rule": "optional"
                          },
                          "booleanValue": {
                            "type": "bool",
                            "id": 7,
                            "rule": "optional"
                          },
                          "selectionUidValues": {
                            "type": "string",
                            "id": 8,
                            "rule": "repeated"
                          },
                          "key": {
                            "type": "string",
                            "id": 9,
                            "rule": "optional"
                          }
                        }
                      },
                      "CatalogTimePeriod": {
                        "fields": {
                          "event": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "almanacEventId": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "CatalogProductSet": {
                        "fields": {
                          "name": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "productIdsAny": {
                            "type": "string",
                            "id": 2,
                            "rule": "repeated"
                          },
                          "productIdsAll": {
                            "type": "string",
                            "id": 3,
                            "rule": "repeated"
                          },
                          "quantityExact": {
                            "type": "int64",
                            "id": 4,
                            "rule": "optional"
                          },
                          "quantityMin": {
                            "type": "int64",
                            "id": 5,
                            "rule": "optional"
                          },
                          "quantityMax": {
                            "type": "int64",
                            "id": 6,
                            "rule": "optional"
                          },
                          "allProducts": {
                            "type": "bool",
                            "id": 7,
                            "rule": "optional"
                          },
                          "matchCustomAmounts": {
                            "type": "bool",
                            "id": 8,
                            "rule": "optional"
                          },
                          "isProductAllTokensBeenCascadeDelete": {
                            "type": "bool",
                            "id": 9,
                            "rule": "optional"
                          },
                          "lineItemTypes": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogProductSetLineItemType",
                            "id": 10,
                            "rule": "repeated"
                          }
                        }
                      },
                      "CatalogPricingRule": {
                        "fields": {
                          "name": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "timePeriodIds": {
                            "type": "string",
                            "id": 2,
                            "rule": "repeated"
                          },
                          "discountId": {
                            "type": "string",
                            "id": 5,
                            "rule": "optional"
                          },
                          "matchProductsId": {
                            "type": "string",
                            "id": 6,
                            "rule": "optional"
                          },
                          "applyProductsId": {
                            "type": "string",
                            "id": 7,
                            "rule": "optional"
                          },
                          "stackable": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.AggregationStrategy",
                            "id": 8,
                            "rule": "optional",
                            "options": {
                              "default": "EXCLUSIVE"
                            }
                          },
                          "excludeProductsId": {
                            "type": "string",
                            "id": 9,
                            "rule": "optional"
                          },
                          "validFromDate": {
                            "type": "string",
                            "id": 10,
                            "rule": "optional"
                          },
                          "validFromLocalTime": {
                            "type": "string",
                            "id": 11,
                            "rule": "optional"
                          },
                          "validUntilDate": {
                            "type": "string",
                            "id": 12,
                            "rule": "optional"
                          },
                          "validUntilLocalTime": {
                            "type": "string",
                            "id": 13,
                            "rule": "optional"
                          },
                          "excludeStrategy": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.ExcludeStrategy",
                            "id": 14,
                            "rule": "optional",
                            "options": {
                              "default": "LEAST_EXPENSIVE"
                            }
                          },
                          "applicationMode": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogPricingRuleApplicationMode",
                            "id": 15,
                            "rule": "optional",
                            "options": {
                              "default": "AUTOMATIC"
                            }
                          },
                          "discountTargetScope": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.DiscountTargetScope",
                            "id": 16,
                            "rule": "optional",
                            "options": {
                              "default": "LINE_ITEM"
                            }
                          },
                          "maxApplicationsPerAttachment": {
                            "type": "int32",
                            "id": 17,
                            "rule": "optional",
                            "options": {
                              "default": -1
                            }
                          },
                          "minimumOrderSubtotalMoney": {
                            "type": "squareup.connect.v2.common.Money",
                            "id": 18,
                            "rule": "optional"
                          },
                          "customerGroupIdsAny": {
                            "type": "string",
                            "id": 19,
                            "rule": "repeated"
                          },
                          "serviceChargeTargetScope": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.ServiceChargeTargetScope",
                            "id": 20,
                            "rule": "optional",
                            "options": {
                              "default": "SURCHARGE_TARGET_SCOPE_LINE_ITEM"
                            }
                          },
                          "serviceChargeId": {
                            "type": "string",
                            "id": 21,
                            "rule": "optional"
                          },
                          "enabledPricingSources": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogPricingSource",
                            "id": 22,
                            "rule": "repeated"
                          },
                          "disabledPricingSources": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogPricingSource",
                            "id": 23,
                            "rule": "repeated"
                          },
                          "paymentTypes": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.PricingRulePaymentType",
                            "id": 24,
                            "rule": "repeated"
                          },
                          "minimumLineItemSubtotalMoney": {
                            "type": "squareup.connect.v2.common.Money",
                            "id": 25,
                            "rule": "optional"
                          },
                          "ecomApplyToFulfillmentTypeServiceCharges": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogServiceChargeEcomFulfillmentType",
                            "id": 26,
                            "rule": "repeated"
                          }
                        }
                      },
                      "CatalogServiceCharge": {
                        "fields": {
                          "name": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "percentage": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "type": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogServiceChargeType",
                            "id": 3,
                            "rule": "optional"
                          },
                          "taxable": {
                            "type": "bool",
                            "id": 4,
                            "rule": "optional",
                            "options": {
                              "default": true
                            }
                          },
                          "calculationPhase": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogServiceChargeCalculationPhase",
                            "id": 5,
                            "rule": "optional",
                            "options": {
                              "default": "SURCHARGE_PHASE"
                            }
                          },
                          "minimumSeatCount": {
                            "type": "uint64",
                            "id": 6,
                            "rule": "optional"
                          },
                          "autoEnableType": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogServiceChargeAutoEnableType",
                            "id": 7,
                            "rule": "optional"
                          },
                          "amountMoney": {
                            "type": "squareup.connect.v2.common.Money",
                            "id": 8,
                            "rule": "optional"
                          },
                          "labelColor": {
                            "type": "string",
                            "id": 9,
                            "rule": "optional"
                          },
                          "legacyTaxIds": {
                            "type": "string",
                            "id": 10,
                            "rule": "repeated"
                          },
                          "calculationType": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogServiceChargeCalculationType",
                            "id": 11,
                            "rule": "optional",
                            "options": {
                              "default": "SURCHARGE_FIXED"
                            }
                          },
                          "ecomApplyToFulfillmentTypes": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogServiceChargeEcomFulfillmentType",
                            "id": 12,
                            "rule": "repeated"
                          },
                          "treatmentType": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogServiceChargeTreatmentType",
                            "id": 13,
                            "rule": "optional",
                            "options": {
                              "default": "SURCHARGE_TREATMENT_LINE_ITEM"
                            }
                          }
                        }
                      },
                      "CatalogSubscriptionPlan": {
                        "fields": {
                          "name": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "phases": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.SubscriptionPhase",
                            "id": 5,
                            "rule": "repeated"
                          },
                          "taxInfo": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.SubscriptionTaxInfo",
                            "id": 6,
                            "rule": "optional"
                          },
                          "configuration": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.SubscriptionConfiguration",
                            "id": 7,
                            "rule": "optional"
                          },
                          "monthlyBillingAnchorDate": {
                            "type": "int64",
                            "id": 18,
                            "rule": "optional"
                          },
                          "canProrate": {
                            "type": "bool",
                            "id": 9,
                            "rule": "optional"
                          },
                          "subscriptionPlanVariations": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogObject",
                            "id": 10,
                            "rule": "repeated"
                          },
                          "eligibleItemIds": {
                            "type": "string",
                            "id": 11,
                            "rule": "repeated"
                          },
                          "eligibleCategoryIds": {
                            "type": "string",
                            "id": 12,
                            "rule": "repeated"
                          },
                          "allItems": {
                            "type": "bool",
                            "id": 13,
                            "rule": "optional"
                          },
                          "tenant": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.Subscriptions.Tenant",
                            "id": 14,
                            "rule": "optional"
                          }
                        }
                      },
                      "CatalogSubscriptionPlanVariation": {
                        "fields": {
                          "name": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "phases": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.SubscriptionPhase",
                            "id": 2,
                            "rule": "repeated"
                          },
                          "taxInfo": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.SubscriptionTaxInfo",
                            "id": 3,
                            "rule": "optional"
                          },
                          "configuration": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.SubscriptionConfiguration",
                            "id": 4,
                            "rule": "optional"
                          },
                          "subscriptionPlanId": {
                            "type": "string",
                            "id": 5,
                            "rule": "optional"
                          },
                          "monthlyBillingAnchorDate": {
                            "type": "int64",
                            "id": 6,
                            "rule": "optional"
                          },
                          "canProrate": {
                            "type": "bool",
                            "id": 7,
                            "rule": "optional"
                          },
                          "successorPlanVariationId": {
                            "type": "string",
                            "id": 8,
                            "rule": "optional"
                          },
                          "tenant": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.Subscriptions.Tenant",
                            "id": 14,
                            "rule": "optional"
                          }
                        }
                      },
                      "SubscriptionPhase": {
                        "fields": {
                          "uid": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "cadence": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.SubscriptionCadence",
                            "id": 3,
                            "rule": "optional"
                          },
                          "periods": {
                            "type": "uint64",
                            "id": 4,
                            "rule": "optional"
                          },
                          "recurringPriceMoney": {
                            "type": "squareup.connect.v2.common.Money",
                            "id": 5,
                            "rule": "optional"
                          },
                          "ordinal": {
                            "type": "int64",
                            "id": 6,
                            "rule": "optional"
                          },
                          "oneTimeFee": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.OneTimeFee",
                            "id": 7,
                            "rule": "optional"
                          },
                          "pricing": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.SubscriptionPricing",
                            "id": 8,
                            "rule": "optional"
                          }
                        }
                      },
                      "OneTimeFee": {
                        "fields": {
                          "priceMoney": {
                            "type": "squareup.connect.v2.common.Money",
                            "id": 1,
                            "rule": "optional"
                          },
                          "description": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "SubscriptionTaxInfo": {
                        "fields": {
                          "sellerCode": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "productCode": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "productClass": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "SubscriptionConfiguration": {
                        "fields": {
                          "buyerAllowIndefinitePausing": {
                            "type": "bool",
                            "id": 1,
                            "rule": "optional"
                          },
                          "buyerMaxCyclesToSkip": {
                            "type": "int64",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "SubscriptionPricing": {
                        "fields": {
                          "type": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.SubscriptionPricingType",
                            "id": 1,
                            "rule": "optional"
                          },
                          "price": {
                            "type": "squareup.connect.v2.common.Money",
                            "id": 2,
                            "rule": "optional"
                          },
                          "discountIds": {
                            "type": "string",
                            "id": 3,
                            "rule": "repeated"
                          },
                          "priceMoney": {
                            "type": "squareup.connect.v2.common.Money",
                            "id": 4,
                            "rule": "optional"
                          }
                        }
                      },
                      "CatalogTicketTemplate": {
                        "fields": {
                          "name": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "ticketGroupId": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "ordinal": {
                            "type": "int32",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "CatalogTicketGroup": {
                        "fields": {
                          "name": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "ordinal": {
                            "type": "int32",
                            "id": 2,
                            "rule": "optional"
                          },
                          "namingMethod": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogTicketGroupNamingMethod",
                            "id": 3,
                            "rule": "optional"
                          },
                          "label": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          },
                          "numberingStartsAt": {
                            "type": "int32",
                            "id": 5,
                            "rule": "optional"
                          },
                          "prefixTableNames": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogTicketGroupPrefixTableNames",
                            "id": 6,
                            "rule": "optional"
                          }
                        }
                      },
                      "CatalogFloorPlan": {
                        "fields": {
                          "name": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "height": {
                            "type": "int32",
                            "id": 2,
                            "rule": "optional",
                            "options": {
                              "default": 1
                            }
                          },
                          "width": {
                            "type": "int32",
                            "id": 3,
                            "rule": "optional",
                            "options": {
                              "default": 1
                            }
                          },
                          "ordinal": {
                            "type": "int32",
                            "id": 4,
                            "rule": "optional"
                          }
                        }
                      },
                      "CatalogFloorPlanTile": {
                        "fields": {
                          "floorPlanId": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "placeholderId": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "ticketTemplateId": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "shape": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogFloorPlanTileShape",
                            "id": 4,
                            "rule": "optional"
                          },
                          "height": {
                            "type": "int32",
                            "id": 5,
                            "rule": "optional",
                            "options": {
                              "default": 1
                            }
                          },
                          "width": {
                            "type": "int32",
                            "id": 6,
                            "rule": "optional",
                            "options": {
                              "default": 1
                            }
                          },
                          "xPosition": {
                            "type": "int32",
                            "id": 7,
                            "rule": "optional",
                            "options": {
                              "default": 0
                            }
                          },
                          "yPosition": {
                            "type": "int32",
                            "id": 8,
                            "rule": "optional",
                            "options": {
                              "default": 0
                            }
                          },
                          "zOrder": {
                            "type": "int32",
                            "id": 9,
                            "rule": "optional",
                            "options": {
                              "default": 0
                            }
                          },
                          "rotationAngle": {
                            "type": "string",
                            "id": 10,
                            "rule": "optional"
                          },
                          "color": {
                            "type": "string",
                            "id": 11,
                            "rule": "optional"
                          }
                        }
                      },
                      "CatalogMeasurementUnit": {
                        "fields": {
                          "measurementUnit": {
                            "type": "squareup.connect.v2.common.MeasurementUnit",
                            "id": 1,
                            "rule": "optional"
                          },
                          "precision": {
                            "type": "int32",
                            "id": 2,
                            "rule": "optional",
                            "options": {
                              "default": 3
                            }
                          }
                        }
                      },
                      "CatalogQuickAmount": {
                        "fields": {
                          "type": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogQuickAmountType",
                            "id": 1,
                            "rule": "optional"
                          },
                          "amount": {
                            "type": "squareup.connect.v2.common.Money",
                            "id": 2,
                            "rule": "optional"
                          },
                          "score": {
                            "type": "int64",
                            "id": 3,
                            "rule": "optional"
                          },
                          "ordinal": {
                            "type": "int64",
                            "id": 4,
                            "rule": "optional"
                          }
                        }
                      },
                      "CatalogQuickAmountsSettings": {
                        "fields": {
                          "option": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogQuickAmountsSettingsOption",
                            "id": 1,
                            "rule": "optional"
                          },
                          "eligibleForAutoAmounts": {
                            "type": "bool",
                            "id": 2,
                            "rule": "optional"
                          },
                          "amounts": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogQuickAmount",
                            "id": 3,
                            "rule": "repeated"
                          }
                        }
                      },
                      "Resource": {
                        "fields": {
                          "name": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "description": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "CatalogCheckoutLink": {
                        "fields": {
                          "name": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "description": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "linkType": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CheckoutLinkType",
                            "id": 3,
                            "rule": "optional"
                          },
                          "enabled": {
                            "type": "bool",
                            "id": 4,
                            "rule": "optional",
                            "options": {
                              "default": true
                            }
                          },
                          "source": {
                            "type": "string",
                            "id": 7,
                            "rule": "optional",
                            "options": {
                              "default": "EXTERNAL_API"
                            }
                          },
                          "referenceId": {
                            "type": "string",
                            "id": 8,
                            "rule": "optional"
                          },
                          "checkoutButton": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CheckoutLinkButtonSettings",
                            "id": 9,
                            "rule": "optional"
                          },
                          "orderDetails": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CheckoutLinkOrderDetails",
                            "id": 10,
                            "rule": "optional"
                          },
                          "subscriptionPlanIds": {
                            "type": "string",
                            "id": 11,
                            "rule": "repeated"
                          },
                          "allowTipping": {
                            "type": "bool",
                            "id": 12,
                            "rule": "optional",
                            "options": {
                              "default": false
                            }
                          },
                          "donationGoal": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CheckoutLinkDonationGoal",
                            "id": 13,
                            "rule": "optional"
                          },
                          "subscriptionOnly": {
                            "type": "bool",
                            "id": 14,
                            "rule": "optional",
                            "options": {
                              "default": false
                            }
                          },
                          "shortUrl": {
                            "type": "string",
                            "id": 15,
                            "rule": "optional"
                          },
                          "longUrl": {
                            "type": "string",
                            "id": 16,
                            "rule": "optional"
                          },
                          "url": {
                            "type": "string",
                            "id": 17,
                            "rule": "optional"
                          },
                          "customFields": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CheckoutLinkCustomField",
                            "id": 18,
                            "rule": "repeated"
                          },
                          "imageIds": {
                            "type": "string",
                            "id": 19,
                            "rule": "repeated"
                          },
                          "redirectUrl": {
                            "type": "string",
                            "id": 20,
                            "rule": "optional"
                          },
                          "paymentNote": {
                            "type": "string",
                            "id": 21,
                            "rule": "optional"
                          }
                        }
                      },
                      "CheckoutLinkButtonSettings": {
                        "fields": {
                          "text": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "color": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "showTitle": {
                            "type": "bool",
                            "id": 3,
                            "rule": "optional",
                            "options": {
                              "default": false
                            }
                          },
                          "showPrice": {
                            "type": "bool",
                            "id": 4,
                            "rule": "optional",
                            "options": {
                              "default": false
                            }
                          }
                        }
                      },
                      "CheckoutLinkDonationGoal": {
                        "fields": {
                          "beginTime": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "endTime": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "target": {
                            "type": "squareup.connect.v2.common.Money",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "CheckoutLinkCustomField": {
                        "fields": {
                          "uid": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "ordinal": {
                            "type": "int64",
                            "id": 2,
                            "rule": "optional"
                          },
                          "name": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "CheckoutLinkOrderDetails": {
                        "fields": {
                          "lineItems": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CheckoutLinkOrderDetailsLineItem",
                            "id": 1,
                            "rule": "repeated"
                          }
                        }
                      },
                      "CheckoutLinkOrderDetailsLineItem": {
                        "fields": {
                          "uid": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "ordinal": {
                            "type": "int64",
                            "id": 2,
                            "rule": "optional"
                          },
                          "quantity": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.QuantityRatio",
                            "id": 3,
                            "rule": "optional"
                          },
                          "itemId": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          },
                          "name": {
                            "type": "string",
                            "id": 5,
                            "rule": "optional"
                          },
                          "priceMoney": {
                            "type": "squareup.connect.v2.common.Money",
                            "id": 6,
                            "rule": "optional"
                          }
                        }
                      },
                      "CatalogObject": {
                        "fields": {
                          "type": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogObjectType",
                            "id": 1,
                            "rule": "optional"
                          },
                          "id": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "updatedAt": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "createdAt": {
                            "type": "string",
                            "id": 132,
                            "rule": "optional"
                          },
                          "version": {
                            "type": "int64",
                            "id": 4,
                            "rule": "optional"
                          },
                          "isDeleted": {
                            "type": "bool",
                            "id": 5,
                            "rule": "optional"
                          },
                          "DEPRECATEDCustomAttributes": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogCustomAttributeValue",
                            "id": 14,
                            "rule": "repeated"
                          },
                          "customAttributeValues": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogCustomAttributeValue",
                            "id": 15,
                            "keyType": "string"
                          },
                          "catalogV1Ids": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogV1Id",
                            "id": 8,
                            "rule": "repeated"
                          },
                          "presentAtAllLocations": {
                            "type": "bool",
                            "id": 9,
                            "rule": "optional",
                            "options": {
                              "default": true
                            }
                          },
                          "presentAtLocationIds": {
                            "type": "string",
                            "id": 10,
                            "rule": "repeated"
                          },
                          "absentAtLocationIds": {
                            "type": "string",
                            "id": 11,
                            "rule": "repeated"
                          },
                          "imageId": {
                            "type": "string",
                            "id": 12,
                            "rule": "optional"
                          },
                          "itemData": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogItem",
                            "id": 101,
                            "rule": "optional"
                          },
                          "categoryData": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogCategory",
                            "id": 104,
                            "rule": "optional"
                          },
                          "itemVariationData": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogItemVariation",
                            "id": 105,
                            "rule": "optional"
                          },
                          "taxData": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogTax",
                            "id": 106,
                            "rule": "optional"
                          },
                          "discountData": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogDiscount",
                            "id": 108,
                            "rule": "optional"
                          },
                          "modifierListData": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogModifierList",
                            "id": 110,
                            "rule": "optional"
                          },
                          "modifierData": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogModifier",
                            "id": 112,
                            "rule": "optional"
                          },
                          "timePeriodData": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogTimePeriod",
                            "id": 113,
                            "rule": "optional"
                          },
                          "productSetData": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogProductSet",
                            "id": 114,
                            "rule": "optional"
                          },
                          "pricingRuleData": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogPricingRule",
                            "id": 115,
                            "rule": "optional"
                          },
                          "imageData": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogImage",
                            "id": 116,
                            "rule": "optional"
                          },
                          "measurementUnitData": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogMeasurementUnit",
                            "id": 117,
                            "rule": "optional"
                          },
                          "subscriptionPlanData": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogSubscriptionPlan",
                            "id": 118,
                            "rule": "optional"
                          },
                          "itemOptionData": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogItemOption",
                            "id": 119,
                            "rule": "optional"
                          },
                          "itemOptionValueData": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogItemOptionValue",
                            "id": 120,
                            "rule": "optional"
                          },
                          "customAttributeDefinitionData": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogCustomAttributeDefinition",
                            "id": 121,
                            "rule": "optional"
                          },
                          "quickAmountsSettingsData": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogQuickAmountsSettings",
                            "id": 122,
                            "rule": "optional"
                          },
                          "taxExemptionData": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogTaxExemption",
                            "id": 123,
                            "rule": "optional"
                          },
                          "diningOptionData": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogDiningOption",
                            "id": 124,
                            "rule": "optional"
                          },
                          "resourceData": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.Resource",
                            "id": 125,
                            "rule": "optional"
                          },
                          "compositionData": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogComposition",
                            "id": 127,
                            "rule": "optional"
                          },
                          "componentData": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogComponent",
                            "id": 128,
                            "rule": "optional"
                          },
                          "serviceChargeData": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogServiceCharge",
                            "id": 129,
                            "rule": "optional"
                          },
                          "checkoutLinkData": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogCheckoutLink",
                            "id": 130,
                            "rule": "optional"
                          },
                          "addressData": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogAddress",
                            "id": 131,
                            "rule": "optional"
                          },
                          "ticketTemplateData": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogTicketTemplate",
                            "id": 134,
                            "rule": "optional"
                          },
                          "voidReasonData": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogVoidReason",
                            "id": 135,
                            "rule": "optional"
                          },
                          "menuData": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogMenu",
                            "id": 137,
                            "rule": "optional"
                          },
                          "menuGroupData": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogMenuGroup",
                            "id": 138,
                            "rule": "optional"
                          },
                          "pageData": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogPage",
                            "id": 139,
                            "rule": "optional"
                          },
                          "pageTileData": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogPageTile",
                            "id": 140,
                            "rule": "optional"
                          },
                          "placeholderData": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogPlaceholder",
                            "id": 141,
                            "rule": "optional"
                          },
                          "tagData": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogTag",
                            "id": 142,
                            "rule": "optional"
                          },
                          "itemVariationVendorInfoData": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogItemVariationVendorInfo",
                            "id": 143,
                            "rule": "optional"
                          },
                          "configurationData": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogConfiguration",
                            "id": 144,
                            "rule": "optional"
                          },
                          "subscriptionPlanVariationData": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogSubscriptionPlanVariation",
                            "id": 145,
                            "rule": "optional"
                          },
                          "availabilityPeriodData": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogAvailabilityPeriod",
                            "id": 146,
                            "rule": "optional"
                          },
                          "ticketGroupData": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogTicketGroup",
                            "id": 147,
                            "rule": "optional"
                          },
                          "floorPlanData": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogFloorPlan",
                            "id": 148,
                            "rule": "optional"
                          },
                          "floorPlanTileData": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogFloorPlanTile",
                            "id": 149,
                            "rule": "optional"
                          },
                          "creditRedemptionPolicyData": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogCreditRedemptionPolicy",
                            "id": 151,
                            "rule": "optional"
                          },
                          "ageRestrictionData": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogAgeRestriction",
                            "id": 152,
                            "rule": "optional"
                          },
                          "favoritesListPositionData": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogFavoritesListPosition",
                            "id": 153,
                            "rule": "optional"
                          },
                          "salePriceData": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogSalePrice",
                            "id": 154,
                            "rule": "optional"
                          },
                          "taxCategoryData": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogTaxCategory",
                            "id": 155,
                            "rule": "optional"
                          }
                        }
                      },
                      "CatalogObjectReference": {
                        "fields": {
                          "objectId": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "catalogVersion": {
                            "type": "int64",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "CatalogCustomAttributeDefinition": {
                        "fields": {
                          "type": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogCustomAttributeDefinition.Type",
                            "id": 1,
                            "rule": "optional"
                          },
                          "name": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "description": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "sourceApplication": {
                            "type": "squareup.connect.v2.common.SourceApplication",
                            "id": 4,
                            "rule": "optional"
                          },
                          "allowedObjectTypes": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogObjectType",
                            "id": 5,
                            "rule": "repeated"
                          },
                          "sellerVisibility": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogCustomAttributeDefinition.SellerVisibility",
                            "id": 7,
                            "rule": "optional",
                            "options": {
                              "default": "SELLER_VISIBILITY_READ_WRITE_VALUES"
                            }
                          },
                          "appVisibility": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogCustomAttributeDefinition.AppVisibility",
                            "id": 8,
                            "rule": "optional",
                            "options": {
                              "default": "APP_VISIBILITY_HIDDEN"
                            }
                          },
                          "stringConfig": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogCustomAttributeDefinition.StringConfig",
                            "id": 9,
                            "rule": "optional"
                          },
                          "numberConfig": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogCustomAttributeDefinition.NumberConfig",
                            "id": 13,
                            "rule": "optional"
                          },
                          "selectionConfig": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogCustomAttributeDefinition.SelectionConfig",
                            "id": 10,
                            "rule": "optional"
                          },
                          "customAttributeUsageCount": {
                            "type": "int32",
                            "id": 11,
                            "rule": "optional"
                          },
                          "key": {
                            "type": "string",
                            "id": 12,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "Type": {
                            "values": {
                              "ATTRIBUTE_TYPE_DO_NOT_USE": 0,
                              "STRING": 1,
                              "INTEGER": 2,
                              "BOOLEAN": 3,
                              "NUMBER": 9,
                              "SELECTION": 10,
                              "STRING_INT": 11,
                              "TOKEN_INT": 12
                            }
                          },
                          "SellerVisibility": {
                            "values": {
                              "SELLER_VISIBILITY_DO_NOT_USE": 0,
                              "SELLER_VISIBILITY_HIDDEN": 1,
                              "SELLER_VISIBILITY_READ_WRITE_VALUES": 2
                            }
                          },
                          "AppVisibility": {
                            "values": {
                              "APP_VISIBILITY_DO_NOT_USE": 0,
                              "APP_VISIBILITY_HIDDEN": 1,
                              "APP_VISIBILITY_READ_ONLY": 2,
                              "APP_VISIBILITY_READ_WRITE_VALUES": 3
                            }
                          },
                          "StringConfig": {
                            "fields": {
                              "enforceUniqueness": {
                                "type": "bool",
                                "id": 1,
                                "rule": "optional"
                              }
                            }
                          },
                          "NumberConfig": {
                            "fields": {
                              "precision": {
                                "type": "int32",
                                "id": 1,
                                "rule": "optional",
                                "options": {
                                  "default": 5
                                }
                              }
                            }
                          },
                          "SelectionConfig": {
                            "fields": {
                              "maxAllowedSelections": {
                                "type": "int32",
                                "id": 1,
                                "rule": "optional"
                              },
                              "allowedSelections": {
                                "type": "squareup.connect.v2.merchant_catalog.resources.CatalogCustomAttributeDefinition.SelectionConfig.CustomAttributeSelection",
                                "id": 2,
                                "rule": "repeated"
                              }
                            },
                            "nested": {
                              "CustomAttributeSelection": {
                                "fields": {
                                  "uid": {
                                    "type": "string",
                                    "id": 1,
                                    "rule": "optional"
                                  },
                                  "name": {
                                    "type": "string",
                                    "id": 2,
                                    "rule": "optional"
                                  }
                                }
                              }
                            }
                          }
                        }
                      },
                      "CatalogItemOption": {
                        "fields": {
                          "name": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "displayName": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "description": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "showColors": {
                            "type": "bool",
                            "id": 4,
                            "rule": "optional"
                          },
                          "values": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogObject",
                            "id": 5,
                            "rule": "repeated"
                          },
                          "itemCount": {
                            "type": "int64",
                            "id": 6,
                            "rule": "optional"
                          }
                        }
                      },
                      "CatalogItemOptionValue": {
                        "fields": {
                          "itemOptionId": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "name": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "description": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "color": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          },
                          "ordinal": {
                            "type": "int32",
                            "id": 5,
                            "rule": "optional"
                          },
                          "itemVariationCount": {
                            "type": "int64",
                            "id": 6,
                            "rule": "optional"
                          }
                        }
                      },
                      "CatalogMenu": {
                        "fields": {
                          "name": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "ordinal": {
                            "type": "int32",
                            "id": 2,
                            "rule": "optional"
                          },
                          "productName": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogProductName",
                            "id": 3,
                            "rule": "optional"
                          },
                          "tagId": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          },
                          "multiUnitMode": {
                            "type": "bool",
                            "id": 5,
                            "rule": "optional"
                          }
                        }
                      },
                      "CatalogMenuGroup": {
                        "fields": {
                          "itemId": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "tagId": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "parentMenuGroupId": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "itemOrdinal": {
                            "type": "int32",
                            "id": 4,
                            "rule": "optional"
                          },
                          "menuGroupOrdinal": {
                            "type": "int32",
                            "id": 5,
                            "rule": "optional"
                          },
                          "productName": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogProductName",
                            "id": 6,
                            "rule": "optional"
                          },
                          "isSyncedMenuGroupMembership": {
                            "type": "bool",
                            "id": 7,
                            "rule": "optional"
                          }
                        }
                      },
                      "CatalogPage": {
                        "fields": {
                          "name": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "tagId": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "pageLayout": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogPageLayout",
                            "id": 3,
                            "rule": "optional"
                          },
                          "pageIndex": {
                            "type": "int32",
                            "id": 4,
                            "rule": "optional"
                          },
                          "multiUnitMode": {
                            "type": "bool",
                            "id": 5,
                            "rule": "optional"
                          }
                        }
                      },
                      "CatalogPageTile": {
                        "fields": {
                          "diningOptionId": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "discountId": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "itemId": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "categoryId": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          },
                          "menuGroupId": {
                            "type": "string",
                            "id": 5,
                            "rule": "optional"
                          },
                          "pageId": {
                            "type": "string",
                            "id": 6,
                            "rule": "optional"
                          },
                          "placeholderId": {
                            "type": "string",
                            "id": 7,
                            "rule": "optional"
                          },
                          "surchargeId": {
                            "type": "string",
                            "id": 8,
                            "rule": "optional"
                          },
                          "tagId": {
                            "type": "string",
                            "id": 9,
                            "rule": "optional"
                          },
                          "row": {
                            "type": "int32",
                            "id": 10,
                            "rule": "optional"
                          },
                          "column": {
                            "type": "int32",
                            "id": 11,
                            "rule": "optional"
                          },
                          "position": {
                            "type": "int32",
                            "id": 12,
                            "rule": "optional"
                          },
                          "width": {
                            "type": "int32",
                            "id": 13,
                            "rule": "optional"
                          },
                          "height": {
                            "type": "int32",
                            "id": 14,
                            "rule": "optional"
                          },
                          "color": {
                            "type": "string",
                            "id": 15,
                            "rule": "optional"
                          },
                          "posDisplayName": {
                            "type": "string",
                            "id": 16,
                            "rule": "optional"
                          },
                          "imageId": {
                            "type": "string",
                            "id": 17,
                            "rule": "optional"
                          },
                          "showTileLabel": {
                            "type": "bool",
                            "id": 18,
                            "rule": "optional"
                          },
                          "useColorBackground": {
                            "type": "bool",
                            "id": 19,
                            "rule": "optional"
                          }
                        }
                      },
                      "CatalogPlaceholder": {
                        "fields": {
                          "name": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "placeholderType": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogPlaceholderType",
                            "id": 2,
                            "rule": "optional"
                          },
                          "multiUnitMode": {
                            "type": "bool",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "CatalogTag": {
                        "fields": {
                          "name": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "productName": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogProductName",
                            "id": 2,
                            "rule": "optional"
                          },
                          "tagType": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogTagType",
                            "id": 3,
                            "rule": "optional"
                          },
                          "color": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          },
                          "categoryId": {
                            "type": "string",
                            "id": 5,
                            "rule": "optional"
                          },
                          "multiUnitMode": {
                            "type": "bool",
                            "id": 6,
                            "rule": "optional"
                          },
                          "imageId": {
                            "type": "string",
                            "id": 17,
                            "rule": "optional"
                          }
                        }
                      },
                      "Event": {
                        "fields": {
                          "uid": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "startAt": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "endAt": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "eventLocationTimeZone": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          },
                          "eventLocationName": {
                            "type": "string",
                            "id": 5,
                            "rule": "optional"
                          },
                          "eventLocationTypes": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.EventLocationType",
                            "id": 6,
                            "rule": "repeated"
                          },
                          "onlineUrl": {
                            "type": "string",
                            "id": 7,
                            "rule": "optional"
                          },
                          "addressId": {
                            "type": "string",
                            "id": 8,
                            "rule": "optional"
                          },
                          "allDayEvent": {
                            "type": "bool",
                            "id": 9,
                            "rule": "optional"
                          }
                        }
                      },
                      "CatalogAddress": {
                        "fields": {
                          "address": {
                            "type": "squareup.connect.v2.resources.Address",
                            "id": 1,
                            "rule": "optional"
                          },
                          "coordinates": {
                            "type": "squareup.connect.v2.common.Coordinates",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "CatalogVoidReason": {
                        "fields": {
                          "name": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "ordinal": {
                            "type": "int32",
                            "id": 2,
                            "rule": "optional"
                          },
                          "appointmentsType": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogVoidReasonAppointmentsType",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "CatalogConfiguration": {
                        "fields": {
                          "pageLayout": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogPageLayout",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "CatalogAvailabilityPeriod": {
                        "fields": {
                          "startLocalTime": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "endLocalTime": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "dayOfWeek": {
                            "type": "squareup.connect.v2.common.DayOfWeek",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "CatalogCreditRedemptionPolicy": {
                        "fields": {
                          "quantity": {
                            "type": "int32",
                            "id": 1,
                            "rule": "optional"
                          },
                          "pricingRuleId": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "itemVariationId": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "CatalogAgeRestriction": {
                        "fields": {
                          "name": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "minimumBuyerAge": {
                            "type": "int32",
                            "id": 2,
                            "rule": "optional"
                          },
                          "minimumBuyerAgeOverrides": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogAgeRestrictionLocationOverrides",
                            "id": 3,
                            "rule": "repeated"
                          }
                        }
                      },
                      "CatalogAgeRestrictionLocationOverrides": {
                        "fields": {
                          "locationId": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "minimumBuyerAge": {
                            "type": "int64",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "CatalogFavoritesListPosition": {
                        "fields": {
                          "position": {
                            "type": "int32",
                            "id": 1,
                            "rule": "optional"
                          },
                          "discountId": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "itemId": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "MultiFieldTextFilter": {
                        "fields": {
                          "textFilter": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "fields": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.MultiFieldTextFilter.FieldValues",
                            "id": 2,
                            "rule": "optional"
                          },
                          "matchWholePhrase": {
                            "type": "bool",
                            "id": 4,
                            "rule": "optional",
                            "options": {
                              "default": false
                            }
                          },
                          "enableFuzzySearch": {
                            "type": "bool",
                            "id": 5,
                            "rule": "optional",
                            "options": {
                              "default": false
                            }
                          }
                        },
                        "nested": {
                          "SearchField": {
                            "values": {
                              "SEARCH_FIELD_DO_NOT_USE": 0,
                              "ITEM_NAME": 1,
                              "ITEM_DESCRIPTION": 2,
                              "ITEM_ABBREVIATION": 3,
                              "ITEM_VARIATION_NAME": 4,
                              "ITEM_VARIATION_SKU": 5,
                              "ITEM_VARIATION_UPC": 6,
                              "ITEM_VARIATION_VENDOR_CODE": 7,
                              "ITEM_CUSTOM_ATTRIBUTES_STRING": 8,
                              "ITEM_VARIATION_CUSTOM_ATTRIBUTES_STRING": 9,
                              "ITEM_CUSTOM_ATTRIBUTES_NUMBER": 10,
                              "ITEM_VARIATION_CUSTOM_ATTRIBUTES_NUMBER": 11,
                              "ITEM_CUSTOM_ATTRIBUTES_SELECTION": 12,
                              "ITEM_VARIATION_CUSTOM_ATTRIBUTES_SELECTION": 13
                            }
                          },
                          "FieldValues": {
                            "fields": {
                              "any": {
                                "type": "squareup.connect.v2.merchant_catalog.resources.MultiFieldTextFilter.SearchField",
                                "id": 1,
                                "rule": "repeated"
                              },
                              "all": {
                                "type": "squareup.connect.v2.merchant_catalog.resources.MultiFieldTextFilter.SearchField",
                                "id": 2,
                                "rule": "repeated"
                              },
                              "none": {
                                "type": "squareup.connect.v2.merchant_catalog.resources.MultiFieldTextFilter.SearchField",
                                "id": 3,
                                "rule": "repeated"
                              }
                            }
                          }
                        }
                      },
                      "CustomAttributeFilter": {
                        "fields": {
                          "customAttributeDefinitionId": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "key": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "stringFilter": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "numberFilter": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.Range",
                            "id": 4,
                            "rule": "optional"
                          },
                          "selectionUidsFilter": {
                            "type": "string",
                            "id": 5,
                            "rule": "repeated"
                          },
                          "boolFilter": {
                            "type": "bool",
                            "id": 6,
                            "rule": "optional"
                          }
                        }
                      },
                      "Range": {
                        "fields": {
                          "min": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "max": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogIdMapping && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogObjectBatch && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogQuery && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogQuery?.nested?.SortedAttribute && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogQuery?.nested?.SortedStringIntAttribute && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogQuery?.nested?.Exact && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogQuery?.nested?.Set && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogQuery?.nested?.Prefix && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogQuery?.nested?.Range && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogQuery?.nested?.BooleanAttribute && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogQuery?.nested?.Text && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogQuery?.nested?.ItemsForTax && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogQuery?.nested?.ItemsForModifierList && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogQuery?.nested?.ItemsForItemOptions && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogQuery?.nested?.ItemVariationsForItemOptionValues && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogQuery?.nested?.PricingObjectsForProducts && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogQuery?.nested?.CheckoutLinksForItems && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogQuery?.nested?.FilteredItems && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogQuery?.nested?.FilteredItems?.nested?.StockLevel && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogQuery?.nested?.FilteredItems?.nested?.CustomAttributeFilter && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogQuery?.nested?.FilteredItems?.nested?.CustomAttributeFilter?.nested?.FilterType && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogQuery?.nested?.FilteredItems?.nested?.NullableAttribute && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogQuery?.nested?.CustomAttributeUsage && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogQuery?.nested?.LegacyIdsAtLocation && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogQuery?.nested?.LegacyIds && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogQuery?.nested?.DoesNotExist && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogQuery?.nested?.PresentAtLocations && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogModifierOverride && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogItemModifierListInfo && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogItemOptionForItem && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogObjectCategory && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogEcomSeoData && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogOpenGraphData && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogItem && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogItem?.nested?.FoodAndBeverageDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogItem?.nested?.FoodAndBeverageDetails?.nested?.DietaryPreferenceType && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogItem?.nested?.FoodAndBeverageDetails?.nested?.DietaryPreference && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogItem?.nested?.FoodAndBeverageDetails?.nested?.DietaryPreference?.nested?.StandardDietaryPreference && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogItem?.nested?.FoodAndBeverageDetails?.nested?.Ingredient && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogItem?.nested?.FoodAndBeverageDetails?.nested?.Ingredient?.nested?.StandardIngredient && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogItem?.nested?.CatalogItemComboTypeDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogItem?.nested?.CatalogItemComboTypeDetails?.nested?.CatalogComboSlot && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.ItemLocationOverrides && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.ItemVariationLocationOverrides && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogItemOptionValueForItemVariation && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.Intermission && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogStockConversion && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.ItemVariationWeight && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogBundle && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogBundleComponent && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.ServiceCost && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogItemVariation && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogItemVariationVendorInformation && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CreditPackageInfo && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogItemVariationVendorInfo && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.QuantityRatio && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogComposition && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogComponent && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.StraightFireType && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CategoryLocationOverrides && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogCategory && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CategoryPathToRootNode && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogTax && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogTaxExemption && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogTaxCategory && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.DiningOptionLocationOverrides && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogDiningOption && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogDiscount && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogSalePrice && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogModifier && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.ModifierLocationOverrides && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogModifierList && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogImage && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.ImageFileData && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogV1Id && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogCustomAttributeValue && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogTimePeriod && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogProductSet && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogPricingRule && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogServiceCharge && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogSubscriptionPlan && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogSubscriptionPlanVariation && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.SubscriptionPhase && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.OneTimeFee && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.SubscriptionTaxInfo && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.SubscriptionConfiguration && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.SubscriptionPricing && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogTicketTemplate && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogTicketGroup && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogFloorPlan && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogFloorPlanTile && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogMeasurementUnit && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogQuickAmount && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogQuickAmountsSettings && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.Resource && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogCheckoutLink && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CheckoutLinkButtonSettings && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CheckoutLinkDonationGoal && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CheckoutLinkCustomField && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CheckoutLinkOrderDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CheckoutLinkOrderDetailsLineItem && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogObject && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogObjectReference && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogCustomAttributeDefinition && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogCustomAttributeDefinition?.nested?.Type && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogCustomAttributeDefinition?.nested?.SellerVisibility && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogCustomAttributeDefinition?.nested?.AppVisibility && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogCustomAttributeDefinition?.nested?.StringConfig && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogCustomAttributeDefinition?.nested?.NumberConfig && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogCustomAttributeDefinition?.nested?.SelectionConfig && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogCustomAttributeDefinition?.nested?.SelectionConfig?.nested?.CustomAttributeSelection && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogItemOption && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogItemOptionValue && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogMenu && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogMenuGroup && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogPage && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogPageTile && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogPlaceholder && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogTag && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.Event && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogAddress && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogVoidReason && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogConfiguration && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogAvailabilityPeriod && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogCreditRedemptionPolicy && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogAgeRestriction && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogAgeRestrictionLocationOverrides && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogFavoritesListPosition && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.MultiFieldTextFilter && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.MultiFieldTextFilter?.nested?.SearchField && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.MultiFieldTextFilter?.nested?.FieldValues && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CustomAttributeFilter && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.Range) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc A mapping between a temporary client-supplied ID and a permanent server-generated ID.
 *
 * When calling [UpsertCatalogObject](api-endpoint:Catalog-UpsertCatalogObject) or
 * [BatchUpsertCatalogObjects](api-endpoint:Catalog-BatchUpsertCatalogObjects) to
 * create a [CatalogObject](entity:CatalogObject) instance, you can supply
 * a temporary ID for the to-be-created object, especially when the object is to be referenced
 * elsewhere in the same request body. This temporary ID can be any string unique within
 * the call, but must be prefixed by "#".
 *
 * After the request is submitted and the object created, a permanent server-generated ID is assigned
 * to the new object. The permanent ID is unique across the Square catalog.
 * --
 *
 * SOURCE CatalogIdMapping @ squareup/connect/v2/catalog/resources/datatypes.proto at 41:1
 */
export const CatalogIdMapping = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogIdMapping');
fixType(CatalogIdMapping);
Builder.createAndAttachToType(CatalogIdMapping);
/**
 * @desc A batch of catalog objects.
 *
 * SOURCE CatalogObjectBatch @ squareup/connect/v2/catalog/resources/datatypes.proto at 54:1
 */
export const CatalogObjectBatch = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogObjectBatch');
fixType(CatalogObjectBatch, {
  objects: {
    required: true
  }
});
Builder.createAndAttachToType(CatalogObjectBatch);
/**
 * --
 * @desc A query composed of one or more different types of filters to narrow the scope of targeted objects when calling the `SearchCatalogObjects` endpoint.
 *
 * Although a query can have multiple filters, only certain query types can be combined per call to [SearchCatalogObjects](api-endpoint:Catalog-SearchCatalogObjects).
 * Any combination of the following types may be used together:
 * - [exact_query](entity:CatalogQueryExact)
 * - [prefix_query](entity:CatalogQueryPrefix)
 * - [range_query](entity:CatalogQueryRange)
 * - [sorted_attribute_query](entity:CatalogQuerySortedAttribute)
 * - [text_query](entity:CatalogQueryText)
 *
 * All other query types cannot be combined with any others.
 *
 * When a query filter is based on an attribute, the attribute must be searchable.
 * Searchable attributes are listed as follows, along their parent types that can be searched for with applicable query filters.
 *
 * Searchable attribute and objects queryable by searchable attributes:
 * - `name`:  `CatalogItem`, `CatalogItemVariation`, `CatalogCategory`, `CatalogTax`, `CatalogDiscount`, `CatalogModifier`, `CatalogModifierList`, `CatalogItemOption`, `CatalogItemOptionValue`
 * - `description`: `CatalogItem`, `CatalogItemOptionValue`
 * - `abbreviation`: `CatalogItem`
 * - `upc`: `CatalogItemVariation`
 * - `sku`: `CatalogItemVariation`
 * - `caption`: `CatalogImage`
 * - `display_name`: `CatalogItemOption`
 *
 * For example, to search for [CatalogItem](entity:CatalogItem) objects by searchable attributes, you can use
 * the `"name"`, `"description"`, or `"abbreviation"` attribute in an applicable query filter.
 * --
 *
 * SOURCE CatalogQuery @ squareup/connect/v2/catalog/resources/datatypes.proto at 89:1
 */
export const CatalogQuery = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogQuery');
fixType(CatalogQuery);
Builder.createAndAttachToType(CatalogQuery);
/**
 * --
 * @desc The query expression to specify the key to sort search results.
 * --
 *
 * SOURCE SortedAttribute @ squareup/connect/v2/catalog/resources/datatypes.proto at 95:5
 */
CatalogQuery.SortedAttribute = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogQuery.SortedAttribute');
fixType(CatalogQuery.SortedAttribute, {
  attributeName: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(CatalogQuery.SortedAttribute);
/**
 * SOURCE SortedStringIntAttribute @ squareup/connect/v2/catalog/resources/datatypes.proto at 114:5
 */
CatalogQuery.SortedStringIntAttribute = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogQuery.SortedStringIntAttribute');
fixType(CatalogQuery.SortedStringIntAttribute, {
  attributeName: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(CatalogQuery.SortedStringIntAttribute);
/**
 * --
 * @desc The query filter to return the search result by exact match of the specified attribute name and value.
 * --
 *
 * SOURCE Exact @ squareup/connect/v2/catalog/resources/datatypes.proto at 134:5
 */
CatalogQuery.Exact = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogQuery.Exact');
fixType(CatalogQuery.Exact, {
  attributeName: {
    notEmpty: true
  },
  attributeValue: {
    required: true
  }
});
Builder.createAndAttachToType(CatalogQuery.Exact);
/**
 * --
 * @desc The query filter to return the search result(s) by exact match of the specified `attribute_name` and any of
 * the `attribute_values`.
 * --
 *
 * SOURCE Set @ squareup/connect/v2/catalog/resources/datatypes.proto at 149:5
 */
CatalogQuery.Set = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogQuery.Set');
fixType(CatalogQuery.Set, {
  attributeName: {
    notEmpty: true
  },
  attributeValues: {
    required: true
  }
});
Builder.createAndAttachToType(CatalogQuery.Set);
/**
 * --
 * @desc The query filter to return the search result whose named attribute values are prefixed by the specified attribute value.
 * --
 *
 * SOURCE Prefix @ squareup/connect/v2/catalog/resources/datatypes.proto at 163:5
 */
CatalogQuery.Prefix = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogQuery.Prefix');
fixType(CatalogQuery.Prefix, {
  attributeName: {
    notEmpty: true
  },
  attributePrefix: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(CatalogQuery.Prefix);
/**
 * --
 * @desc The query filter to return the search result whose named attribute values fall between the specified range.
 * --
 *
 * SOURCE Range @ squareup/connect/v2/catalog/resources/datatypes.proto at 174:5
 */
CatalogQuery.Range = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogQuery.Range');
fixType(CatalogQuery.Range, {
  attributeName: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(CatalogQuery.Range);
/**
 * --
 * @desc The query filter to return the search result whose named attribute has the specified boolean value.
 *
 * SOURCE BooleanAttribute @ squareup/connect/v2/catalog/resources/datatypes.proto at 188:5
 */
CatalogQuery.BooleanAttribute = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogQuery.BooleanAttribute');
fixType(CatalogQuery.BooleanAttribute, {
  attributeName: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(CatalogQuery.BooleanAttribute);
/**
 * --
 * @desc The query filter to return the search result whose searchable attribute values contain all of the specified keywords or tokens, independent of the token order or case.
 * --
 *
 * SOURCE Text @ squareup/connect/v2/catalog/resources/datatypes.proto at 202:5
 */
CatalogQuery.Text = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogQuery.Text');
fixType(CatalogQuery.Text, {
  keywords: {
    required: true
  }
});
Builder.createAndAttachToType(CatalogQuery.Text);
/**
 * --
 * @desc The query filter to return the items containing the specified tax IDs.
 * --
 *
 * SOURCE ItemsForTax @ squareup/connect/v2/catalog/resources/datatypes.proto at 212:5
 */
CatalogQuery.ItemsForTax = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogQuery.ItemsForTax');
fixType(CatalogQuery.ItemsForTax, {
  taxIds: {
    required: true
  }
});
Builder.createAndAttachToType(CatalogQuery.ItemsForTax);
/**
 * --
 * @desc The query filter to return the items containing the specified modifier list IDs.
 * --
 *
 * SOURCE ItemsForModifierList @ squareup/connect/v2/catalog/resources/datatypes.proto at 220:5
 */
CatalogQuery.ItemsForModifierList = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogQuery.ItemsForModifierList');
fixType(CatalogQuery.ItemsForModifierList, {
  modifierListIds: {
    required: true
  }
});
Builder.createAndAttachToType(CatalogQuery.ItemsForModifierList);
/**
 * --
 * @desc The query filter to return the items containing the specified item option IDs.
 * --
 *
 * SOURCE ItemsForItemOptions @ squareup/connect/v2/catalog/resources/datatypes.proto at 228:5
 */
CatalogQuery.ItemsForItemOptions = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogQuery.ItemsForItemOptions');
fixType(CatalogQuery.ItemsForItemOptions);
Builder.createAndAttachToType(CatalogQuery.ItemsForItemOptions);
/**
 * --
 * @desc The query filter to return the item variations containing the specified item option value IDs.
 * --
 *
 * SOURCE ItemVariationsForItemOptionValues @ squareup/connect/v2/catalog/resources/datatypes.proto at 242:5
 */
CatalogQuery.ItemVariationsForItemOptionValues = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogQuery.ItemVariationsForItemOptionValues');
fixType(CatalogQuery.ItemVariationsForItemOptionValues);
Builder.createAndAttachToType(CatalogQuery.ItemVariationsForItemOptionValues);
/**
 * --
 * @desc The query filter to return the pricing rules containing the specified product IDs.
 * --
 *
 * SOURCE PricingObjectsForProducts @ squareup/connect/v2/catalog/resources/datatypes.proto at 256:5
 */
CatalogQuery.PricingObjectsForProducts = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogQuery.PricingObjectsForProducts');
fixType(CatalogQuery.PricingObjectsForProducts);
Builder.createAndAttachToType(CatalogQuery.PricingObjectsForProducts);
/**
 * --
 * @desc The query filter to return the checkout links containing the specified item IDs.
 * --
 *
 * SOURCE CheckoutLinksForItems @ squareup/connect/v2/catalog/resources/datatypes.proto at 320:5
 */
CatalogQuery.CheckoutLinksForItems = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogQuery.CheckoutLinksForItems');
fixType(CatalogQuery.CheckoutLinksForItems);
Builder.createAndAttachToType(CatalogQuery.CheckoutLinksForItems);
/**
 * @desc Supported query expressions to search for items or item variations.
 * When supplying any of the query expressions, be aware that newly created or updated
 * items or item variations may not appear in the search result if the search request
 * is submitted in 5 seconds or less after the items are created or updated. In this
 * case, the search result may include the items or item variations with old data if they
 * are updated, or the search result may not include the items or item variations at all
 * if they are newly created.
 *
 * SOURCE FilteredItems @ squareup/connect/v2/catalog/resources/datatypes.proto at 334:5
 */
CatalogQuery.FilteredItems = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogQuery.FilteredItems');
fixType(CatalogQuery.FilteredItems);
Builder.createAndAttachToType(CatalogQuery.FilteredItems);
/**
 * @desc Supported stock levels in the item inventory.
 *
 * SOURCE StockLevel @ squareup/connect/v2/catalog/resources/datatypes.proto at 353:9
 */
CatalogQuery.FilteredItems.StockLevel = $root.lookupEnum('squareup.connect.v2.merchant_catalog.resources.CatalogQuery.FilteredItems.StockLevel').values;
/**
 * @desc A query filter to search for items or item variations by matching
 * their custom attribute values against one or more of the supported query expressions.
 *
 * SOURCE CustomAttributeFilter @ squareup/connect/v2/catalog/resources/datatypes.proto at 380:9
 */
CatalogQuery.FilteredItems.CustomAttributeFilter = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogQuery.FilteredItems.CustomAttributeFilter');
fixType(CatalogQuery.FilteredItems.CustomAttributeFilter);
Builder.createAndAttachToType(CatalogQuery.FilteredItems.CustomAttributeFilter);
/**
 * @desc Supported types of a custom attribute query expression.
 *
 * SOURCE FilterType @ squareup/connect/v2/catalog/resources/datatypes.proto at 382:13
 */
CatalogQuery.FilteredItems.CustomAttributeFilter.FilterType = $root.lookupEnum('squareup.connect.v2.merchant_catalog.resources.CatalogQuery.FilteredItems.CustomAttributeFilter.FilterType').values;
/**
 * @desc Supported nullable attributes that can be used in a query expression to return
 * items or item variations if values of the specified attribute on the items or item
 * variations match the associated query expression or the specified attribute do not exist
 * on the items or item variations.
 *
 * SOURCE NullableAttribute @ squareup/connect/v2/catalog/resources/datatypes.proto at 434:9
 */
CatalogQuery.FilteredItems.NullableAttribute = $root.lookupEnum('squareup.connect.v2.merchant_catalog.resources.CatalogQuery.FilteredItems.NullableAttribute').values;
/**
 * SOURCE CustomAttributeUsage @ squareup/connect/v2/catalog/resources/datatypes.proto at 448:5
 */
CatalogQuery.CustomAttributeUsage = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogQuery.CustomAttributeUsage');
fixType(CatalogQuery.CustomAttributeUsage);
Builder.createAndAttachToType(CatalogQuery.CustomAttributeUsage);
/**
 * @desc a set of legacy object ids associated with a location_id.
 *
 * SOURCE LegacyIdsAtLocation @ squareup/connect/v2/catalog/resources/datatypes.proto at 462:5
 */
CatalogQuery.LegacyIdsAtLocation = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogQuery.LegacyIdsAtLocation');
fixType(CatalogQuery.LegacyIdsAtLocation);
Builder.createAndAttachToType(CatalogQuery.LegacyIdsAtLocation);
/**
 * @desc A query expression to return objects with a given set of legacy ids at a set of locations.
 *
 * SOURCE LegacyIds @ squareup/connect/v2/catalog/resources/datatypes.proto at 470:5
 */
CatalogQuery.LegacyIds = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogQuery.LegacyIds');
fixType(CatalogQuery.LegacyIds);
Builder.createAndAttachToType(CatalogQuery.LegacyIds);
/**
 * SOURCE DoesNotExist @ squareup/connect/v2/catalog/resources/datatypes.proto at 476:5
 */
CatalogQuery.DoesNotExist = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogQuery.DoesNotExist');
fixType(CatalogQuery.DoesNotExist, {
  attributeName: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(CatalogQuery.DoesNotExist);
/**
 * @desc A query expression to search for objects that are present at any of the specified locations.
 *
 * SOURCE PresentAtLocations @ squareup/connect/v2/catalog/resources/datatypes.proto at 484:5
 */
CatalogQuery.PresentAtLocations = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogQuery.PresentAtLocations');
fixType(CatalogQuery.PresentAtLocations, {
  locationIds: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(CatalogQuery.PresentAtLocations);
/**
 * --
 * @desc Options to control how to override the default behavior of the specified modifier.
 * --
 *
 * SOURCE CatalogModifierOverride @ squareup/connect/v2/catalog/resources/datatypes.proto at 575:1
 */
export const CatalogModifierOverride = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogModifierOverride');
fixType(CatalogModifierOverride, {
  modifierId: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(CatalogModifierOverride);
/**
 * --
 * @desc References a text-based modifier or a list of non text-based modifiers applied to a `CatalogItem` instance
 * and specifies supported behaviors of the application.
 * --
 *
 * SOURCE CatalogItemModifierListInfo @ squareup/connect/v2/catalog/resources/datatypes.proto at 591:1
 */
export const CatalogItemModifierListInfo = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogItemModifierListInfo');
fixType(CatalogItemModifierListInfo, {
  modifierListId: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(CatalogItemModifierListInfo);
/**
 * --
 * @desc  An option that can be assigned to an item.
 * For example, a t-shirt item may offer a color option or a size option.
 * --
 *
 * SOURCE CatalogItemOptionForItem @ squareup/connect/v2/catalog/resources/datatypes.proto at 647:1
 */
export const CatalogItemOptionForItem = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogItemOptionForItem');
fixType(CatalogItemOptionForItem);
Builder.createAndAttachToType(CatalogItemOptionForItem);
/**
 * --
 * @desc A category that can be assigned to an item or a parent category that can be assigned
 * to another category. For example, a clothing category can be assigned to a t-shirt item or
 * be made as the parent category to the pants category.
 *
 * --
 *
 * SOURCE CatalogObjectCategory @ squareup/connect/v2/catalog/resources/datatypes.proto at 661:1
 */
export const CatalogObjectCategory = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogObjectCategory');
fixType(CatalogObjectCategory);
Builder.createAndAttachToType(CatalogObjectCategory);
/**
 * @desc SEO data for for a seller's Square Online store.
 *
 * SOURCE CatalogEcomSeoData @ squareup/connect/v2/catalog/resources/datatypes.proto at 673:1
 */
export const CatalogEcomSeoData = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogEcomSeoData');
fixType(CatalogEcomSeoData);
Builder.createAndAttachToType(CatalogEcomSeoData);
/**
 * --
 * @desc Represents [OpenGraph](https://ogp.me/) metadata for an item or category.
 * --
 *
 * SOURCE CatalogOpenGraphData @ squareup/connect/v2/catalog/resources/datatypes.proto at 689:1
 */
export const CatalogOpenGraphData = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogOpenGraphData');
fixType(CatalogOpenGraphData);
Builder.createAndAttachToType(CatalogOpenGraphData);
/**
 * @desc A [CatalogObject](entity:CatalogObject) instance of the `ITEM` type, also referred to as an item, in the catalog.
 *
 * SOURCE CatalogItem @ squareup/connect/v2/catalog/resources/datatypes.proto at 701:1
 */
export const CatalogItem = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogItem');
fixType(CatalogItem);
Builder.createAndAttachToType(CatalogItem);
/**
 * @desc The food and beverage-specific details of a `FOOD_AND_BEV` item.
 *
 * SOURCE FoodAndBeverageDetails @ squareup/connect/v2/catalog/resources/datatypes.proto at 945:5
 */
CatalogItem.FoodAndBeverageDetails = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogItem.FoodAndBeverageDetails');
fixType(CatalogItem.FoodAndBeverageDetails);
Builder.createAndAttachToType(CatalogItem.FoodAndBeverageDetails);
/**
 * @desc The type of dietary preference for the `FOOD_AND_BEV` type of items and integredients.
 *
 * SOURCE DietaryPreferenceType @ squareup/connect/v2/catalog/resources/datatypes.proto at 952:9
 */
CatalogItem.FoodAndBeverageDetails.DietaryPreferenceType = $root.lookupEnum('squareup.connect.v2.merchant_catalog.resources.CatalogItem.FoodAndBeverageDetails.DietaryPreferenceType').values;
/**
 * @desc Dietary preferences that can be assigned to an `FOOD_AND_BEV` item and its ingredients.
 *
 * SOURCE DietaryPreference @ squareup/connect/v2/catalog/resources/datatypes.proto at 961:9
 */
CatalogItem.FoodAndBeverageDetails.DietaryPreference = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogItem.FoodAndBeverageDetails.DietaryPreference');
fixType(CatalogItem.FoodAndBeverageDetails.DietaryPreference);
Builder.createAndAttachToType(CatalogItem.FoodAndBeverageDetails.DietaryPreference);
/**
 * @desc Standard dietary preferences for food and beverage items that are recommended on item creation.
 *
 * SOURCE StandardDietaryPreference @ squareup/connect/v2/catalog/resources/datatypes.proto at 966:13
 */
CatalogItem.FoodAndBeverageDetails.DietaryPreference.StandardDietaryPreference = $root.lookupEnum('squareup.connect.v2.merchant_catalog.resources.CatalogItem.FoodAndBeverageDetails.DietaryPreference.StandardDietaryPreference').values;
/**
 * @desc Describes the ingredient used in a `FOOD_AND_BEV` item.
 *
 * SOURCE Ingredient @ squareup/connect/v2/catalog/resources/datatypes.proto at 987:9
 */
CatalogItem.FoodAndBeverageDetails.Ingredient = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogItem.FoodAndBeverageDetails.Ingredient');
fixType(CatalogItem.FoodAndBeverageDetails.Ingredient);
Builder.createAndAttachToType(CatalogItem.FoodAndBeverageDetails.Ingredient);
/**
 * @desc Standard ingredients for food and beverage items that are recommended on item creation.
 *
 * SOURCE StandardIngredient @ squareup/connect/v2/catalog/resources/datatypes.proto at 992:13
 */
CatalogItem.FoodAndBeverageDetails.Ingredient.StandardIngredient = $root.lookupEnum('squareup.connect.v2.merchant_catalog.resources.CatalogItem.FoodAndBeverageDetails.Ingredient.StandardIngredient').values;
/**
 * @desc Describes component choices of a `COMBO` item.
 *
 * SOURCE CatalogItemComboTypeDetails @ squareup/connect/v2/catalog/resources/datatypes.proto at 1025:5
 */
CatalogItem.CatalogItemComboTypeDetails = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogItem.CatalogItemComboTypeDetails');
fixType(CatalogItem.CatalogItemComboTypeDetails);
Builder.createAndAttachToType(CatalogItem.CatalogItemComboTypeDetails);
/**
 * @desc Represents a choice of a `COMBO` item, also known as a combo slot.
 *
 * SOURCE CatalogComboSlot @ squareup/connect/v2/catalog/resources/datatypes.proto at 1033:9
 */
CatalogItem.CatalogItemComboTypeDetails.CatalogComboSlot = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogItem.CatalogItemComboTypeDetails.CatalogComboSlot');
fixType(CatalogItem.CatalogItemComboTypeDetails.CatalogComboSlot, {
  uid: {
    required: true,
    notEmpty: true
  },
  numSelections: {
    required: true
  }
});
Builder.createAndAttachToType(CatalogItem.CatalogItemComboTypeDetails.CatalogComboSlot);
/**
 * @desc Ordinal overrides for a `CatalogItem` at a specific `Location`.
 *
 * SOURCE ItemLocationOverrides @ squareup/connect/v2/catalog/resources/datatypes.proto at 1086:1
 */
export const ItemLocationOverrides = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.ItemLocationOverrides');
fixType(ItemLocationOverrides);
Builder.createAndAttachToType(ItemLocationOverrides);
/**
 * @desc Price and inventory alerting overrides for a `CatalogItemVariation` at a specific `Location`.
 *
 * SOURCE ItemVariationLocationOverrides @ squareup/connect/v2/catalog/resources/datatypes.proto at 1100:1
 */
export const ItemVariationLocationOverrides = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.ItemVariationLocationOverrides');
fixType(ItemVariationLocationOverrides);
Builder.createAndAttachToType(ItemVariationLocationOverrides);
/**
 * --
 * @desc A `CatalogItemOptionValue` links an item variation to an item option as
 * an item option value. For example, a t-shirt item may offer a color option and
 * a size option. An item option value would represent each variation of t-shirt:
 * For example, "Color:Red, Size:Small" or "Color:Blue, Size:Medium".
 * --
 *
 * SOURCE CatalogItemOptionValueForItemVariation @ squareup/connect/v2/catalog/resources/datatypes.proto at 1170:1
 */
export const CatalogItemOptionValueForItemVariation = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogItemOptionValueForItemVariation');
fixType(CatalogItemOptionValueForItemVariation);
Builder.createAndAttachToType(CatalogItemOptionValueForItemVariation);
/**
 * --
 * @desc An [Intermission](entity:Intermission) represents a non-blocking period of time within a service.
 * --
 *
 * SOURCE Intermission @ squareup/connect/v2/catalog/resources/datatypes.proto at 1184:1
 */
export const Intermission = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.Intermission');
fixType(Intermission);
Builder.createAndAttachToType(Intermission);
/**
 * --
 * @desc Represents the rule of conversion between a stockable [CatalogItemVariation](entity:CatalogItemVariation)
 * and a non-stockable sell-by or receive-by `CatalogItemVariation` that
 * share the same underlying stock.
 * --
 *
 * SOURCE CatalogStockConversion @ squareup/connect/v2/catalog/resources/datatypes.proto at 1200:1
 */
export const CatalogStockConversion = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogStockConversion');
fixType(CatalogStockConversion, {
  stockableItemVariationId: {
    required: true,
    notEmpty: true
  },
  stockableQuantity: {
    required: true,
    notEmpty: true
  },
  nonstockableQuantity: {
    required: true,
    notEmpty: true
  }
});
Builder.createAndAttachToType(CatalogStockConversion);
/**
 * --
 * @desc Represent the weight of an ItemVariation
 * --
 *
 * SOURCE ItemVariationWeight @ squareup/connect/v2/catalog/resources/datatypes.proto at 1247:1
 */
export const ItemVariationWeight = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.ItemVariationWeight');
fixType(ItemVariationWeight);
Builder.createAndAttachToType(ItemVariationWeight);
/**
 * @desc A fixed grouping of [CatalogItemVariation](entity:CatalogItemVariation).  Read-only for now.
 *
 * SOURCE CatalogBundle @ squareup/connect/v2/catalog/resources/datatypes.proto at 1259:1
 */
export const CatalogBundle = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogBundle');
fixType(CatalogBundle, {
  quantityRatio: {
    required: true
  }
});
Builder.createAndAttachToType(CatalogBundle);
/**
 * @desc A component of a [CatalogBundle](entity:CatalogBundle). Read-only for now.
 *
 * SOURCE CatalogBundleComponent @ squareup/connect/v2/catalog/resources/datatypes.proto at 1273:1
 */
export const CatalogBundleComponent = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogBundleComponent');
fixType(CatalogBundleComponent, {
  quantityRatio: {
    required: true
  },
  variationId: {
    required: true,
    notEmpty: true
  }
});
Builder.createAndAttachToType(CatalogBundleComponent);
/**
 * --
 * @desc Cost of materials required to perform an appointments service.
 * --
 *
 * SOURCE ServiceCost @ squareup/connect/v2/catalog/resources/datatypes.proto at 1292:1
 */
export const ServiceCost = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.ServiceCost');
fixType(ServiceCost);
Builder.createAndAttachToType(ServiceCost);
/**
 * --
 * @desc An item variation, representing a product for sale, in the Catalog object model. Each [item](entity:CatalogItem) must have at least one
 * item variation and can have at most 250 item variations.
 *
 * An item variation can be sellable, stockable, or both if it has a unit of measure for its count for the sold number of the variation, the stocked
 * number of the variation, or both. For example, when a variation representing wine is stocked and sold by the bottle, the variation is both
 * stockable and sellable. But when a variation of the wine is sold by the glass, the sold units cannot be used as a measure of the stocked units. This by-the-glass
 * variation is sellable, but not stockable. To accurately keep track of the wine's inventory count at any time, the sellable count must be
 * converted to stockable count. Typically, the seller defines this unit conversion. For example, 1 bottle equals 5 glasses. The Square API exposes
 * the `stockable_conversion` property on the variation to specify the conversion. Thus, when two glasses of the wine are sold, the sellable count
 * decreases by 2, and the stockable count automatically decreases by 0.4 bottle according to the conversion.
 * --
 *
 * SOURCE CatalogItemVariation @ squareup/connect/v2/catalog/resources/datatypes.proto at 1321:1
 */
export const CatalogItemVariation = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogItemVariation');
fixType(CatalogItemVariation);
Builder.createAndAttachToType(CatalogItemVariation);
/**
 * --
 * @desc Information about the vendor of an item variation.
 * --
 *
 * SOURCE CatalogItemVariationVendorInformation @ squareup/connect/v2/catalog/resources/datatypes.proto at 1581:1
 */
export const CatalogItemVariationVendorInformation = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogItemVariationVendorInformation');
fixType(CatalogItemVariationVendorInformation);
Builder.createAndAttachToType(CatalogItemVariationVendorInformation);
/**
 * SOURCE CreditPackageInfo @ squareup/connect/v2/catalog/resources/datatypes.proto at 1605:1
 */
export const CreditPackageInfo = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CreditPackageInfo');
fixType(CreditPackageInfo);
Builder.createAndAttachToType(CreditPackageInfo);
/**
 * SOURCE CatalogItemVariationVendorInfo @ squareup/connect/v2/catalog/resources/datatypes.proto at 1612:1
 */
export const CatalogItemVariationVendorInfo = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogItemVariationVendorInfo');
fixType(CatalogItemVariationVendorInfo);
Builder.createAndAttachToType(CatalogItemVariationVendorInfo);
/**
 * @desc A whole number or unreduced fractional ratio.
 *
 * SOURCE QuantityRatio @ squareup/connect/v2/catalog/resources/datatypes.proto at 1624:1
 */
export const QuantityRatio = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.QuantityRatio');
fixType(QuantityRatio);
Builder.createAndAttachToType(QuantityRatio);
/**
 * @desc A composition is formed of 1 or more components.
 * Objects of this type are referenced by exactly one CatalogItemVariation by id.
 *
 * SOURCE CatalogComposition @ squareup/connect/v2/catalog/resources/datatypes.proto at 1640:1
 */
export const CatalogComposition = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogComposition');
fixType(CatalogComposition);
Builder.createAndAttachToType(CatalogComposition);
/**
 * @desc Represents a part of a composition.
 * The component [CatalogItemVariation](entity:CatalogItemVariation) is referenced by id.
 * Note: [CatalogBundleComponent](entity:CatalogBundleComponent) is the type used within the nested [CatalogBundle](entity:CatalogBundle) type.
 *
 * SOURCE CatalogComponent @ squareup/connect/v2/catalog/resources/datatypes.proto at 1656:1
 */
export const CatalogComponent = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogComponent');
fixType(CatalogComponent);
Builder.createAndAttachToType(CatalogComponent);
/**
 * Describes whether the object should always straight fire by default
 * or never straight fire by default.
 *
 * SOURCE StraightFireType @ squareup/connect/v2/catalog/resources/datatypes.proto at 1671:1
 */
export const StraightFireType = $root.lookupEnum('squareup.connect.v2.merchant_catalog.resources.StraightFireType').values;
/**
 * SOURCE CategoryLocationOverrides @ squareup/connect/v2/catalog/resources/datatypes.proto at 1682:1
 */
export const CategoryLocationOverrides = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CategoryLocationOverrides');
fixType(CategoryLocationOverrides);
Builder.createAndAttachToType(CategoryLocationOverrides);
/**
 * @desc A category to which a `CatalogItem` instance belongs.
 *
 * SOURCE CatalogCategory @ squareup/connect/v2/catalog/resources/datatypes.proto at 1696:1
 */
export const CatalogCategory = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogCategory');
fixType(CatalogCategory);
Builder.createAndAttachToType(CatalogCategory);
/**
 * @desc A node in the path from a retrieved category to its root node.
 *
 * SOURCE CategoryPathToRootNode @ squareup/connect/v2/catalog/resources/datatypes.proto at 1773:1
 */
export const CategoryPathToRootNode = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CategoryPathToRootNode');
fixType(CategoryPathToRootNode);
Builder.createAndAttachToType(CategoryPathToRootNode);
/**
 * @desc A tax applicable to an item.
 *
 * SOURCE CatalogTax @ squareup/connect/v2/catalog/resources/datatypes.proto at 1785:1
 */
export const CatalogTax = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogTax');
fixType(CatalogTax);
Builder.createAndAttachToType(CatalogTax);
/**
 * @desc A conditional tax exemption for non-taxable goods and services. Supported conditions include
 * `dining_option`, `max_total_amount`, `min_item_price` and `max_item_price`.
 * Exactly one condition is allowed for a tax exemption.
 *
 * SOURCE CatalogTaxExemption @ squareup/connect/v2/catalog/resources/datatypes.proto at 1833:1
 */
export const CatalogTaxExemption = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogTaxExemption');
fixType(CatalogTaxExemption, {
  taxId: {
    required: true
  }
});
Builder.createAndAttachToType(CatalogTaxExemption);
/**
 * @desc A tax category applicable to an item.
 *
 * SOURCE CatalogTaxCategory @ squareup/connect/v2/catalog/resources/datatypes.proto at 1922:1
 */
export const CatalogTaxCategory = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogTaxCategory');
fixType(CatalogTaxCategory);
Builder.createAndAttachToType(CatalogTaxCategory);
/**
 * @desc Ordinal overrides for a `CatalogDiningOption` at a specific `Location`.
 *
 * SOURCE DiningOptionLocationOverrides @ squareup/connect/v2/catalog/resources/datatypes.proto at 1929:1
 */
export const DiningOptionLocationOverrides = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.DiningOptionLocationOverrides');
fixType(DiningOptionLocationOverrides);
Builder.createAndAttachToType(DiningOptionLocationOverrides);
/**
 * @desc A dining option in the Catalog object model.
 *
 * SOURCE CatalogDiningOption @ squareup/connect/v2/catalog/resources/datatypes.proto at 1943:1
 */
export const CatalogDiningOption = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogDiningOption');
fixType(CatalogDiningOption);
Builder.createAndAttachToType(CatalogDiningOption);
/**
 * @desc A discount applicable to items.
 *
 * SOURCE CatalogDiscount @ squareup/connect/v2/catalog/resources/datatypes.proto at 1963:1
 */
export const CatalogDiscount = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogDiscount');
fixType(CatalogDiscount);
Builder.createAndAttachToType(CatalogDiscount);
/**
 * --
 * @desc This object tracks the type of Sale Price applied. Sale prices can be of two types:
 * SALE_PRICE_TYPE_FIXED_AMOUNT and SALE_PRICE_TYPE_FIXED_PERCENTAGE
 *
 * Example: An item originally priced at $100 with a FIXED AMOUNT sale price of $80 would be sold at $80.
 * Similarly, the same item with a FIXED PERCENTAGE sale price of 20% would also be sold at $80.
 * --
 *
 * SOURCE CatalogSalePrice @ squareup/connect/v2/catalog/resources/datatypes.proto at 2035:1
 */
export const CatalogSalePrice = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogSalePrice');
fixType(CatalogSalePrice);
Builder.createAndAttachToType(CatalogSalePrice);
/**
 * @desc A modifier applicable to items at the time of sale. An example of a modifier is a Cheese add-on to a Burger item.
 *
 * SOURCE CatalogModifier @ squareup/connect/v2/catalog/resources/datatypes.proto at 2074:1
 */
export const CatalogModifier = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogModifier');
fixType(CatalogModifier);
Builder.createAndAttachToType(CatalogModifier);
/**
 * @desc Location-specific overrides for specified properties of a `CatalogModifier` object.
 *
 * SOURCE ModifierLocationOverrides @ squareup/connect/v2/catalog/resources/datatypes.proto at 2113:1
 */
export const ModifierLocationOverrides = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.ModifierLocationOverrides');
fixType(ModifierLocationOverrides);
Builder.createAndAttachToType(ModifierLocationOverrides);
/**
 * --
 * @desc For a text-based modifier, this encapsulates the modifier's text when its `modifier_type` is `TEXT`.
 * For example, to sell T-shirts with custom prints, a text-based modifier can be used to capture the buyer-supplied
 * text string to be selected for the T-shirt at the time of sale.
 *
 * For non text-based modifiers, this encapsulates a non-empty list of modifiers applicable to items
 * at the time of sale. Each element of the modifier list is a `CatalogObject` instance of the `MODIFIER` type.
 * For example, a "Condiments" modifier list applicable to a "Hot Dog" item
 * may contain "Ketchup", "Mustard", and "Relish" modifiers.
 *
 * A non text-based modifier can be applied to the modified item once or multiple times, if the `selection_type` field
 * is set to `SINGLE` or `MULTIPLE`, respectively. On the other hand, a text-based modifier can be applied to the item
 * only once and the `selection_type` field is always set to `SINGLE`.
 * --
 *
 * SOURCE CatalogModifierList @ squareup/connect/v2/catalog/resources/datatypes.proto at 2154:1
 */
export const CatalogModifierList = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogModifierList');
fixType(CatalogModifierList);
Builder.createAndAttachToType(CatalogModifierList);
/**
 * --
 * @desc An image file to use in Square catalogs. It can be associated with
 * `CatalogItem`, `CatalogItemVariation`, `CatalogCategory`, and `CatalogModifierList` objects.
 * Only the images on items and item variations are exposed in Dashboard.
 * Only the first image on an item is displayed in Square Point of Sale (SPOS).
 * Images on items and variations are displayed through Square Online Store.
 * Images on other object types are for use by 3rd party application developers.
 * --
 * Checkout links are not yet public. When they are exposed the following changes shoudld be made:
 * It can be associated with `CatalogItem`, `CatalogItemVariation`, `CatalogCategory`, `CatalogModifierList`,
 * and `CatalogCheckoutLink` objects.
 * Images on items, variations, and checkout links are displayed through Square Online Store.
 *
 * SOURCE CatalogImage @ squareup/connect/v2/catalog/resources/datatypes.proto at 2257:1
 */
export const CatalogImage = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogImage');
fixType(CatalogImage);
Builder.createAndAttachToType(CatalogImage);
/**
 * --
 * @desc Image data in bytes. Used to add image data into protos to allow for request forwarding of image uploads.
 * --
 *
 * SOURCE ImageFileData @ squareup/connect/v2/catalog/resources/datatypes.proto at 2293:1
 */
export const ImageFileData = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.ImageFileData');
fixType(ImageFileData);
Builder.createAndAttachToType(ImageFileData);
/**
 * @desc A Square API V1 identifier of an item, including the object ID and its associated location ID.
 *
 * SOURCE CatalogV1Id @ squareup/connect/v2/catalog/resources/datatypes.proto at 2302:1
 */
export const CatalogV1Id = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogV1Id');
fixType(CatalogV1Id);
Builder.createAndAttachToType(CatalogV1Id);
/**
 * --
 * @desc An instance of a custom attribute. Custom attributes can be defined and
 * added to `ITEM` and `ITEM_VARIATION` type catalog objects.
 * [Read more about custom attributes](https://developer.squareup.com/docs/catalog-api/add-custom-attributes).
 * --
 *
 * SOURCE CatalogCustomAttributeValue @ squareup/connect/v2/catalog/resources/datatypes.proto at 2317:1
 */
export const CatalogCustomAttributeValue = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogCustomAttributeValue');
fixType(CatalogCustomAttributeValue);
Builder.createAndAttachToType(CatalogCustomAttributeValue);
/**
 * Subset of Items V1 object types. The tag numbers match the ones defined for Items V3.
 * --
 * @desc Represents a time period - either a single period or a repeating period.
 * --
 *
 * SOURCE CatalogTimePeriod @ squareup/connect/v2/catalog/resources/datatypes.proto at 2361:1
 */
export const CatalogTimePeriod = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogTimePeriod');
fixType(CatalogTimePeriod);
Builder.createAndAttachToType(CatalogTimePeriod);
/**
 * --
 * @desc Represents a collection of catalog objects for the purpose of applying a
 * `PricingRule`. Including a catalog object will include all of its subtypes.
 * For example, including a category in a product set will include all of its
 * items and associated item variations in the product set. Including an item in
 * a product set will also include its item variations.
 * --
 *
 * SOURCE CatalogProductSet @ squareup/connect/v2/catalog/resources/datatypes.proto at 2397:1
 */
export const CatalogProductSet = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogProductSet');
fixType(CatalogProductSet);
Builder.createAndAttachToType(CatalogProductSet);
/**
 * --
 * @desc Defines how discounts are automatically applied to a set of items that match the pricing rule
 * during the active time period.
 * --
 *
 * SOURCE CatalogPricingRule @ squareup/connect/v2/catalog/resources/datatypes.proto at 2480:1
 */
export const CatalogPricingRule = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogPricingRule');
fixType(CatalogPricingRule);
Builder.createAndAttachToType(CatalogPricingRule);
/**
 * @desc A service charge in the Catalog object model. Note that `AUTO_GRATUITY` service charge can be applied only in one location.
 *
 * SOURCE CatalogServiceCharge @ squareup/connect/v2/catalog/resources/datatypes.proto at 2653:1
 */
export const CatalogServiceCharge = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogServiceCharge');
fixType(CatalogServiceCharge);
Builder.createAndAttachToType(CatalogServiceCharge);
/**
 * --
 * @desc Describes a subscription plan. A subscription plan represents what you want to sell in a subscription model, and includes references to each of the associated subscription plan variations.
 * For more information, see [Subscription Plans and Variations](https://developer.squareup.com/docs/subscriptions-api/plans-and-variations).
 * --
 *
 * SOURCE CatalogSubscriptionPlan @ squareup/connect/v2/catalog/resources/datatypes.proto at 2728:1
 */
export const CatalogSubscriptionPlan = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogSubscriptionPlan');
fixType(CatalogSubscriptionPlan, {
  name: {
    required: true
  }
});
Builder.createAndAttachToType(CatalogSubscriptionPlan);
/**
 * --
 * @desc Describes a subscription plan variation. A subscription plan variation represents how the subscription for a product or service is sold.
 * For more information, see [Subscription Plans and Variations](https://developer.squareup.com/docs/subscriptions-api/plans-and-variations).
 * --
 *
 * SOURCE CatalogSubscriptionPlanVariation @ squareup/connect/v2/catalog/resources/datatypes.proto at 2806:1
 */
export const CatalogSubscriptionPlanVariation = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogSubscriptionPlanVariation');
fixType(CatalogSubscriptionPlanVariation, {
  name: {
    required: true
  },
  phases: {
    required: true
  }
});
Builder.createAndAttachToType(CatalogSubscriptionPlanVariation);
/**
 * --
 * @desc Describes a phase in a subscription plan variation. For more information, see [Subscription Plans and Variations](https://developer.squareup.com/docs/subscriptions-api/plans-and-variations).
 * --
 *
 * SOURCE SubscriptionPhase @ squareup/connect/v2/catalog/resources/datatypes.proto at 2870:1
 */
export const SubscriptionPhase = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.SubscriptionPhase');
fixType(SubscriptionPhase, {
  cadence: {
    required: true
  }
});
Builder.createAndAttachToType(SubscriptionPhase);
/**
 * --
 * @desc Describes the initial, one-time, fee for a subscription phase.
 * --
 *
 * SOURCE OneTimeFee @ squareup/connect/v2/catalog/resources/datatypes.proto at 2914:1
 */
export const OneTimeFee = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.OneTimeFee');
fixType(OneTimeFee, {
  priceMoney: {
    required: true
  },
  description: {
    required: true,
    notEmpty: true
  }
});
Builder.createAndAttachToType(OneTimeFee);
/**
 * --
 * @desc Describes the information to be used when calculating taxes for subscriptions.
 * --
 *
 * SOURCE SubscriptionTaxInfo @ squareup/connect/v2/catalog/resources/datatypes.proto at 2926:1
 */
export const SubscriptionTaxInfo = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.SubscriptionTaxInfo');
fixType(SubscriptionTaxInfo, {
  sellerCode: {
    required: true,
    notEmpty: true
  },
  productCode: {
    required: true,
    notEmpty: true
  },
  productClass: {
    required: true,
    notEmpty: true
  }
});
Builder.createAndAttachToType(SubscriptionTaxInfo);
/**
 * --
 * @desc Describes the configuration for the subscription.
 * --
 *
 * SOURCE SubscriptionConfiguration @ squareup/connect/v2/catalog/resources/datatypes.proto at 2937:1
 */
export const SubscriptionConfiguration = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.SubscriptionConfiguration');
fixType(SubscriptionConfiguration);
Builder.createAndAttachToType(SubscriptionConfiguration);
/**
 * --
 * @desc Describes the pricing for the subscription.
 * --
 *
 * SOURCE SubscriptionPricing @ squareup/connect/v2/catalog/resources/datatypes.proto at 2952:1
 */
export const SubscriptionPricing = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.SubscriptionPricing');
fixType(SubscriptionPricing);
Builder.createAndAttachToType(SubscriptionPricing);
/**
 * --
 * @desc Describes a ticket template.
 * --
 *
 * SOURCE CatalogTicketTemplate @ squareup/connect/v2/catalog/resources/datatypes.proto at 2984:1
 */
export const CatalogTicketTemplate = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogTicketTemplate');
fixType(CatalogTicketTemplate, {
  name: {
    notEmpty: true
  },
  ticketGroupId: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(CatalogTicketTemplate);
/**
 * SOURCE CatalogTicketGroup @ squareup/connect/v2/catalog/resources/datatypes.proto at 3007:1
 */
export const CatalogTicketGroup = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogTicketGroup');
fixType(CatalogTicketGroup, {
  name: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(CatalogTicketGroup);
/**
 * SOURCE CatalogFloorPlan @ squareup/connect/v2/catalog/resources/datatypes.proto at 3043:1
 */
export const CatalogFloorPlan = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogFloorPlan');
fixType(CatalogFloorPlan, {
  name: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(CatalogFloorPlan);
/**
 * SOURCE CatalogFloorPlanTile @ squareup/connect/v2/catalog/resources/datatypes.proto at 3069:1
 */
export const CatalogFloorPlanTile = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogFloorPlanTile');
fixType(CatalogFloorPlanTile);
Builder.createAndAttachToType(CatalogFloorPlanTile);
/**
 * --
 * @desc Represents the unit used to measure a `CatalogItemVariation` and
 * specifies the precision for decimal quantities.
 * --
 *
 * SOURCE CatalogMeasurementUnit @ squareup/connect/v2/catalog/resources/datatypes.proto at 3134:1
 */
export const CatalogMeasurementUnit = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogMeasurementUnit');
fixType(CatalogMeasurementUnit);
Builder.createAndAttachToType(CatalogMeasurementUnit);
/**
 * --
 * @desc Represents a Quick Amount in the Catalog.
 * --
 *
 * SOURCE CatalogQuickAmount @ squareup/connect/v2/catalog/resources/datatypes.proto at 3159:1
 */
export const CatalogQuickAmount = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogQuickAmount');
fixType(CatalogQuickAmount, {
  type: {
    required: true
  },
  amount: {
    required: true
  }
});
Builder.createAndAttachToType(CatalogQuickAmount);
/**
 * --
 * @desc A parent Catalog Object model represents a set of Quick Amounts and the settings control the amounts.
 * --
 *
 * SOURCE CatalogQuickAmountsSettings @ squareup/connect/v2/catalog/resources/datatypes.proto at 3194:1
 */
export const CatalogQuickAmountsSettings = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogQuickAmountsSettings');
fixType(CatalogQuickAmountsSettings, {
  option: {
    required: true
  }
});
Builder.createAndAttachToType(CatalogQuickAmountsSettings);
/**
 * --
 * @desc Represents a resource necessary for performing a service.
 * E.g. a room required for a bikini wax, or a table for a massage.
 * --
 *
 * SOURCE Resource @ squareup/connect/v2/catalog/resources/datatypes.proto at 3220:1
 */
export const Resource = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.Resource');
fixType(Resource);
Builder.createAndAttachToType(Resource);
/**
 * --
 * @desc Describes a Catalog checkout link.
 * --
 *
 * SOURCE CatalogCheckoutLink @ squareup/connect/v2/catalog/resources/datatypes.proto at 3234:1
 */
export const CatalogCheckoutLink = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogCheckoutLink');
fixType(CatalogCheckoutLink, {
  name: {
    notEmpty: true
  },
  linkType: {
    required: true
  }
});
Builder.createAndAttachToType(CatalogCheckoutLink);
/**
 * SOURCE CheckoutLinkButtonSettings @ squareup/connect/v2/catalog/resources/datatypes.proto at 3339:1
 */
export const CheckoutLinkButtonSettings = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CheckoutLinkButtonSettings');
fixType(CheckoutLinkButtonSettings);
Builder.createAndAttachToType(CheckoutLinkButtonSettings);
/**
 * SOURCE CheckoutLinkDonationGoal @ squareup/connect/v2/catalog/resources/datatypes.proto at 3365:1
 */
export const CheckoutLinkDonationGoal = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CheckoutLinkDonationGoal');
fixType(CheckoutLinkDonationGoal, {
  beginTime: {
    required: true
  },
  endTime: {
    required: true
  },
  target: {
    required: true
  }
});
Builder.createAndAttachToType(CheckoutLinkDonationGoal);
/**
 * SOURCE CheckoutLinkCustomField @ squareup/connect/v2/catalog/resources/datatypes.proto at 3385:1
 */
export const CheckoutLinkCustomField = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CheckoutLinkCustomField');
fixType(CheckoutLinkCustomField, {
  name: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(CheckoutLinkCustomField);
/**
 * SOURCE CheckoutLinkOrderDetails @ squareup/connect/v2/catalog/resources/datatypes.proto at 3405:1
 */
export const CheckoutLinkOrderDetails = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CheckoutLinkOrderDetails');
fixType(CheckoutLinkOrderDetails);
Builder.createAndAttachToType(CheckoutLinkOrderDetails);
/**
 * SOURCE CheckoutLinkOrderDetailsLineItem @ squareup/connect/v2/catalog/resources/datatypes.proto at 3415:1
 */
export const CheckoutLinkOrderDetailsLineItem = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CheckoutLinkOrderDetailsLineItem');
fixType(CheckoutLinkOrderDetailsLineItem);
Builder.createAndAttachToType(CheckoutLinkOrderDetailsLineItem);
/**
 * --
 * @desc The wrapper object for the catalog entries of a given object type.
 *
 * Depending on the `type` attribute value, a `CatalogObject` instance assumes a type-specific data to yield the corresponding type of catalog object.
 *
 * For example, if `type=ITEM`, the `CatalogObject` instance must have the ITEM-specific data set on the `item_data` attribute. The resulting `CatalogObject` instance is also a `CatalogItem` instance.
 *
 * In general, if `type=<OBJECT_TYPE>`, the `CatalogObject` instance must have the `<OBJECT_TYPE>`-specific data set on the `<object_type>_data` attribute. The resulting `CatalogObject` instance is also a `Catalog<ObjectType>` instance.
 *
 * For a more detailed discussion of the Catalog data model, please see the
 * [Design a Catalog](https://developer.squareup.com/docs/catalog-api/design-a-catalog) guide.
 * --
 *
 * SOURCE CatalogObject @ squareup/connect/v2/catalog/resources/datatypes.proto at 3465:1
 */
export const CatalogObject = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogObject');
fixType(CatalogObject, {
  type: {
    required: true
  },
  id: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(CatalogObject);
/**
 * --
 * @desc A reference to a Catalog object at a specific version. In general this is
 * used as an entry point into a graph of catalog objects, where the objects exist
 * at a specific version.
 * --
 *
 * SOURCE CatalogObjectReference @ squareup/connect/v2/catalog/resources/datatypes.proto at 3716:1
 */
export const CatalogObjectReference = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogObjectReference');
fixType(CatalogObjectReference);
Builder.createAndAttachToType(CatalogObjectReference);
/**
 * --
 * @desc Contains information defining a custom attribute. Custom attributes are
 * intended to store additional information about a catalog object or to associate a
 * catalog object with an entity in another system. Do not use custom attributes
 * to store any sensitive information (personally identifiable information, card details, etc.).
 * [Read more about custom attributes](https://developer.squareup.com/docs/catalog-api/add-custom-attributes)
 * --
 *
 * SOURCE CatalogCustomAttributeDefinition @ squareup/connect/v2/catalog/resources/datatypes.proto at 3737:1
 */
export const CatalogCustomAttributeDefinition = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogCustomAttributeDefinition');
fixType(CatalogCustomAttributeDefinition, {
  type: {
    required: true
  },
  name: {
    notEmpty: true
  },
  allowedObjectTypes: {
    required: true
  }
});
Builder.createAndAttachToType(CatalogCustomAttributeDefinition);
/**
 * --
 * @desc Defines the possible types for a custom attribute.
 * --
 *
 * SOURCE Type @ squareup/connect/v2/catalog/resources/datatypes.proto at 3744:5
 */
CatalogCustomAttributeDefinition.Type = $root.lookupEnum('squareup.connect.v2.merchant_catalog.resources.CatalogCustomAttributeDefinition.Type').values;
/**
 * Formerly used for `displayed_object_types`
 * --
 * @desc Defines the visibility of a custom attribute to sellers in Square
 * client applications, Square APIs or in Square UIs (including Square Point
 * of Sale applications and Square Dashboard).
 * --
 *
 * SOURCE SellerVisibility @ squareup/connect/v2/catalog/resources/datatypes.proto at 3818:5
 */
CatalogCustomAttributeDefinition.SellerVisibility = $root.lookupEnum('squareup.connect.v2.merchant_catalog.resources.CatalogCustomAttributeDefinition.SellerVisibility').values;
/**
 * --
 * @desc Defines the visibility of a custom attribute to applications other than their
 * creating application.
 * --
 *
 * SOURCE AppVisibility @ squareup/connect/v2/catalog/resources/datatypes.proto at 3845:5
 */
CatalogCustomAttributeDefinition.AppVisibility = $root.lookupEnum('squareup.connect.v2.merchant_catalog.resources.CatalogCustomAttributeDefinition.AppVisibility').values;
/**
 * --
 * @desc Configuration associated with Custom Attribute Definitions of type `STRING`.
 * --
 *
 * SOURCE StringConfig @ squareup/connect/v2/catalog/resources/datatypes.proto at 3876:5
 */
CatalogCustomAttributeDefinition.StringConfig = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogCustomAttributeDefinition.StringConfig');
fixType(CatalogCustomAttributeDefinition.StringConfig);
Builder.createAndAttachToType(CatalogCustomAttributeDefinition.StringConfig);
/**
 * SOURCE NumberConfig @ squareup/connect/v2/catalog/resources/datatypes.proto at 3891:5
 */
CatalogCustomAttributeDefinition.NumberConfig = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogCustomAttributeDefinition.NumberConfig');
fixType(CatalogCustomAttributeDefinition.NumberConfig);
Builder.createAndAttachToType(CatalogCustomAttributeDefinition.NumberConfig);
/**
 * --
 * @desc Configuration associated with `SELECTION`-type custom attribute definitions.
 * --
 *
 * SOURCE SelectionConfig @ squareup/connect/v2/catalog/resources/datatypes.proto at 3912:5
 */
CatalogCustomAttributeDefinition.SelectionConfig = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogCustomAttributeDefinition.SelectionConfig');
fixType(CatalogCustomAttributeDefinition.SelectionConfig);
Builder.createAndAttachToType(CatalogCustomAttributeDefinition.SelectionConfig);
/**
 * --
 * @desc A named selection for this `SELECTION`-type custom attribute definition.
 * --
 *
 * SOURCE CustomAttributeSelection @ squareup/connect/v2/catalog/resources/datatypes.proto at 3924:9
 */
CatalogCustomAttributeDefinition.SelectionConfig.CustomAttributeSelection = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogCustomAttributeDefinition.SelectionConfig.CustomAttributeSelection');
fixType(CatalogCustomAttributeDefinition.SelectionConfig.CustomAttributeSelection, {
  name: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(CatalogCustomAttributeDefinition.SelectionConfig.CustomAttributeSelection);
/**
 * --
 * @desc A group of variations for a `CatalogItem`.
 * --
 *
 * SOURCE CatalogItemOption @ squareup/connect/v2/catalog/resources/datatypes.proto at 3968:1
 */
export const CatalogItemOption = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogItemOption');
fixType(CatalogItemOption);
Builder.createAndAttachToType(CatalogItemOption);
/**
 * --
 * @desc An enumerated value that can link a
 * `CatalogItemVariation` to an item option as one of
 * its item option values.
 * --
 *
 * SOURCE CatalogItemOptionValue @ squareup/connect/v2/catalog/resources/datatypes.proto at 4010:1
 */
export const CatalogItemOptionValue = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogItemOptionValue');
fixType(CatalogItemOptionValue);
Builder.createAndAttachToType(CatalogItemOptionValue);
/**
 * --
 * @desc An object representing a Menu.
 *
 * A Menu must be enabled at a single unit (i.e., `present_at_all_locations` must be `false`),
 * unless multi_unit_mode is enabled.
 * --
 *
 * SOURCE CatalogMenu @ squareup/connect/v2/catalog/resources/datatypes.proto at 4054:1
 */
export const CatalogMenu = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogMenu');
fixType(CatalogMenu);
Builder.createAndAttachToType(CatalogMenu);
/**
 * --
 * @desc An object representing a MenuGroup. A MenuGroup must have a member that is either an Item or a parent MenuGroup.
 *
 * A MenuGroup must be enabled at a single unit (i.e., `present_at_all_locations` must be `false`).
 * --
 *
 * SOURCE CatalogMenuGroup @ squareup/connect/v2/catalog/resources/datatypes.proto at 4078:1
 */
export const CatalogMenuGroup = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogMenuGroup');
fixType(CatalogMenuGroup);
Builder.createAndAttachToType(CatalogMenuGroup);
/**
 * --
 * @desc An object representing a page of tiles in a Square Point of Sale app.
 *
 * A Page must be enabled at a single unit (i.e., `present_at_all_locations` must be `false`),
 * unless multi unit mode is enabled.
 * --
 *
 * SOURCE CatalogPage @ squareup/connect/v2/catalog/resources/datatypes.proto at 4108:1
 */
export const CatalogPage = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogPage');
fixType(CatalogPage);
Builder.createAndAttachToType(CatalogPage);
/**
 * --
 * @desc An object representing a tile within a page of tiles in a Square Point of Sale app.
 * Only one of the `*_id` fields may be set.
 *
 * A PageTile must be enabled at a single unit (i.e., `present_at_all_locations` must be `false`).
 * --
 *
 * SOURCE CatalogPageTile @ squareup/connect/v2/catalog/resources/datatypes.proto at 4133:1
 */
export const CatalogPageTile = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogPageTile');
fixType(CatalogPageTile);
Builder.createAndAttachToType(CatalogPageTile);
/**
 * --
 * @desc An object representing a placeholder within a page of tiles in a Square Point of Sale app.
 * Only one of the `*_id` fields may be set.
 *
 * A Placeholder must be enabled at a single unit (i.e., `present_at_all_locations` must be `false`),
 * unless multi_unit_mode is enabled.
 * --
 *
 * SOURCE CatalogPlaceholder @ squareup/connect/v2/catalog/resources/datatypes.proto at 4202:1
 */
export const CatalogPlaceholder = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogPlaceholder');
fixType(CatalogPlaceholder);
Builder.createAndAttachToType(CatalogPlaceholder);
/**
 * --
 * @desc An object representing a tag within a page of tiles in a Square Point of Sale app.
 * Only one of the `*_id` fields may be set.
 *
 * A Tag must be enabled at a single unit (i.e., `present_at_all_locations` must be `false`),
 * unless multi_unit_mode is enabled.
 * --
 *
 * SOURCE CatalogTag @ squareup/connect/v2/catalog/resources/datatypes.proto at 4222:1
 */
export const CatalogTag = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogTag');
fixType(CatalogTag);
Builder.createAndAttachToType(CatalogTag);
/**
 * --
 * @desc Event information associated with an event item
 * --
 *
 * SOURCE Event @ squareup/connect/v2/catalog/resources/datatypes.proto at 4478:1
 */
export const Event = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.Event');
fixType(Event);
Builder.createAndAttachToType(Event);
/**
 * --
 * @desc A physical address.
 * --
 *
 * SOURCE CatalogAddress @ squareup/connect/v2/catalog/resources/datatypes.proto at 4512:1
 */
export const CatalogAddress = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogAddress');
fixType(CatalogAddress);
Builder.createAndAttachToType(CatalogAddress);
/**
 * --
 * @desc A reason that can be attached to an itemization that has been voided in a cart.
 * Examples: "Entry error", "Customer changed mind", "Item no longer available".
 *
 * SOURCE CatalogVoidReason @ squareup/connect/v2/catalog/resources/datatypes.proto at 4524:1
 */
export const CatalogVoidReason = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogVoidReason');
fixType(CatalogVoidReason);
Builder.createAndAttachToType(CatalogVoidReason);
/**
 * --
 * @desc Stores the page layout to be used by the Square Point Of Sale app for a given location.
 *
 * SOURCE CatalogConfiguration @ squareup/connect/v2/catalog/resources/datatypes.proto at 4539:1
 */
export const CatalogConfiguration = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogConfiguration');
fixType(CatalogConfiguration);
Builder.createAndAttachToType(CatalogConfiguration);
/**
 * --
 * @desc Represents a time period of availability.
 * --
 *
 * SOURCE CatalogAvailabilityPeriod @ squareup/connect/v2/catalog/resources/datatypes.proto at 4550:1
 */
export const CatalogAvailabilityPeriod = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogAvailabilityPeriod');
fixType(CatalogAvailabilityPeriod);
Builder.createAndAttachToType(CatalogAvailabilityPeriod);
/**
 * SOURCE CatalogCreditRedemptionPolicy @ squareup/connect/v2/catalog/resources/datatypes.proto at 4571:1
 */
export const CatalogCreditRedemptionPolicy = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogCreditRedemptionPolicy');
fixType(CatalogCreditRedemptionPolicy);
Builder.createAndAttachToType(CatalogCreditRedemptionPolicy);
/**
 * --
 * @desc An Age Restriction represents the minimum age a buyer must be to purchase an item in the Catalog object model.
 * Each age restriction record has a name, an age, and optionally location specific overrides
 * --
 *
 * SOURCE CatalogAgeRestriction @ squareup/connect/v2/catalog/resources/datatypes.proto at 4595:1
 */
export const CatalogAgeRestriction = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogAgeRestriction');
fixType(CatalogAgeRestriction);
Builder.createAndAttachToType(CatalogAgeRestriction);
/**
 * @desc Minimum buyer age overrides for a `CatalogAgeRestriction` at a specific `Location`.
 *
 * SOURCE CatalogAgeRestrictionLocationOverrides @ squareup/connect/v2/catalog/resources/datatypes.proto at 4612:1
 */
export const CatalogAgeRestrictionLocationOverrides = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogAgeRestrictionLocationOverrides');
fixType(CatalogAgeRestrictionLocationOverrides);
Builder.createAndAttachToType(CatalogAgeRestrictionLocationOverrides);
/**
 * --
 * @desc Deprecated in favor of Menus. For internal compatibility only.
 * A Favorites List Position represents an element in an ordered list of Favorites List items. It can refer
 * to items or discounts. Each position value should be unique within a location.
 * --
 *
 * SOURCE CatalogFavoritesListPosition @ squareup/connect/v2/catalog/resources/datatypes.proto at 4627:1
 */
export const CatalogFavoritesListPosition = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CatalogFavoritesListPosition');
fixType(CatalogFavoritesListPosition);
Builder.createAndAttachToType(CatalogFavoritesListPosition);
/**
 * --
 * @desc A filter for specifying which attributes to consider in a text search.
 * --
 *
 * SOURCE MultiFieldTextFilter @ squareup/connect/v2/catalog/resources/datatypes.proto at 4652:1
 */
export const MultiFieldTextFilter = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.MultiFieldTextFilter');
fixType(MultiFieldTextFilter);
Builder.createAndAttachToType(MultiFieldTextFilter);
/**
 * @desc Defines searchable attributes supported by MultiFieldTextFilter.
 *
 * SOURCE SearchField @ squareup/connect/v2/catalog/resources/datatypes.proto at 4655:5
 */
MultiFieldTextFilter.SearchField = $root.lookupEnum('squareup.connect.v2.merchant_catalog.resources.MultiFieldTextFilter.SearchField').values;
/**
 * @desc Specifies how each attribute should be considered when filtering.
 *
 * SOURCE FieldValues @ squareup/connect/v2/catalog/resources/datatypes.proto at 4672:5
 */
MultiFieldTextFilter.FieldValues = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.MultiFieldTextFilter.FieldValues');
fixType(MultiFieldTextFilter.FieldValues);
Builder.createAndAttachToType(MultiFieldTextFilter.FieldValues);
/**
 * --
 * @desc Supported custom attribute query expressions for calling item and item variation search endpoints.
 * --
 *
 * SOURCE CustomAttributeFilter @ squareup/connect/v2/catalog/resources/datatypes.proto at 4694:1
 */
export const CustomAttributeFilter = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.CustomAttributeFilter');
fixType(CustomAttributeFilter);
Builder.createAndAttachToType(CustomAttributeFilter);
/**
 * --
 * @desc The range of a number value between the specified lower and upper bounds.
 * --
 *
 * SOURCE Range @ squareup/connect/v2/catalog/resources/datatypes.proto at 4731:1
 */
export const Range = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.Range');
fixType(Range);
Builder.createAndAttachToType(Range);